export const common = {
  // Navigation
  'nav.slogan': 'Një verdikt AI për idenë tënde — para se të ndërtosh',
  'nav.features': 'Veçoritë',
  'nav.howItWorks': 'Si funksionon',
  'nav.pricing': 'Çmimet',
  'nav.faq': 'Pyetjet e shpeshta',
  'nav.aboutUs': 'Rreth nesh',
  'nav.getStarted': 'Filloni',

  // About Us Section
  'aboutUs.badge': "Rreth Nesh",
  'aboutUs.title': "Pse ekziston IdeaVerdict",
  'aboutUs.line1': "Kushdo mund të ketë një ide.",
  'aboutUs.line2': "Pak e pranojnë se e tyrja nuk do të mbijetojë.",
  'aboutUs.paragraph1': "Shumica e ideve nuk dështojnë sepse themeluesve u mungoi guximi. Ato dështojnë sepse askush nuk e tha të vërtetën në kohë. IdeaVerdict mbush atë boshllëk — të vërtetën e pakëndshme që miqtë tuaj nuk do t'jua thonë, ne do t'jua themi.",
  'aboutUs.belief1a': "Ne nuk shesim zhurmë.",
  'aboutUs.belief1b': "Ne shesim sinjale tregu.",
  'aboutUs.belief2a': "Ne nuk shesim motivim.",
  'aboutUs.belief2b': "Ne shesim analizë të qartë të kërkesës, konkurrencës dhe fizibilitetit.",
  'aboutUs.mission1': "Puna jonë nuk është ta bëjmë idenë tuaj të duket mirë.",
  'aboutUs.mission2': "Puna jonë është t'ju themi nëse vërtet është e tillë.",
  'aboutUs.analysis': "IdeaVerdict teston idetë mbi atë që ka rëndësi — strukturën e tregut, kërkesën reale, konkurrencën, kapitalin e kërkuar, kohën deri te të ardhurat, shkallëzueshmërinë. Pa emocione. Pa optimizëm. Vetëm analizë.",
  'aboutUs.failure1': "Shumica e bizneseve dështojnë.",
  'aboutUs.failure2': "Jo sepse njerëzit pas tyre ishin të paaftë —",
  'aboutUs.failure3': "por sepse askush nuk e bëri pyetjen e vështirë në kohë.",
  'aboutUs.clarity': "Ne jemi këtu për ta bërë atë.",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Honest.",
  'aboutUs.value3': "Fast.",
  'aboutUs.confirm': "If your idea has substance, we back it.",
  'aboutUs.deny': "If it doesn't, we say it to your face.",
  'aboutUs.noApplause': "No applause.",
  'aboutUs.noSugarcoating': "No sugar-coating.",
  'aboutUs.noTheater': "No theatre.",
  'aboutUs.noHype': "Just the verdict.",
  // Hero Section
  'hero.badge': 'Verdikt AI në më pak se 60 sekonda',
  'hero.title1': 'Mos ndërto',
  'hero.title2': 'para se të kontrollosh.',
  'hero.subtitle': 'IdeaVerdict teston idenë tënde si një VC skeptik.',
  'hero.subtitleLine2': 'Verdikt i sinqertë në sekonda — pa hype, pa lajka.',
  'hero.cta': 'Merr verdiktin tim',
  'hero.ctaSecondary': 'Si funksionon',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Kredi për kërkesë',
  'hero.stat2Value': 'Nga 7',
  'hero.stat2Label': 'Dimensione të vlerësimit',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ndershëm dhe Privat',

  // Features Section
  'features.title1': 'Krijuar për',
  'features.title2': 'themeluesit që',
  'features.title3': 'duan të vërtetën',
  'features.bullet1.title': 'Verdikt i ndershëm në sekonda',
  'features.bullet1.description': 'I fortë, I përzier ose I dobët — me arsyetimin pas çdo vlerësimi. Pa duartrokitje, pa zbukurim, pa teatër.',
  'features.bullet2.title': 'Vlerësuar mbi atë që ka rëndësi',
  'features.bullet2.description': 'Ideja juaj vlerësohet mbi kërkesën reale, konkurrencën, kapitalin e kërkuar, kohën deri te të ardhurat dhe shkallëzueshmërinë — jo ndjenjat.',
  'features.bullet3.title': 'Nga verdikti te ndërtimi',
  'features.bullet3.description': 'Modaliteti Builder e kthen një ide të miratuar në një udhëzues për zhvilluesit: rrjedhat e përdoruesit, veçoritë kryesore, shënimet teknike.',

  // How It Works
  'howItWorks.title': 'Si funksionon',
  'howItWorks.subtitle': 'Katër hapa drejt qartësisë për kamaen tuaj të biznesit.',
  'howItWorks.step1Title': 'Zgjidhni një plan',
  'howItWorks.step1Desc': 'Fillestar, Pro ose Ndërtues – në varësi të thellësisë së shqyrtimit tuaj.',
  'howItWorks.step2Title': 'Pyetni AI-në',
  'howItWorks.step2Desc': 'Bëni pyetjet tuaja rreth kamaes. Çdo kërkesë kushton 30 kredi.',
  'howItWorks.step3Title': 'Merrni verdiktin e ndershëm',
  'howItWorks.step3Desc': 'AI vlerëson: Mirë, Mesatar ose Keq. Pa sheqerosje.',
  'howItWorks.step4Title': 'Merrni një vendim',
  'howItWorks.step4Desc': 'Tani e dini nëse ia vlen të ecni përpara.',

  // Pricing
  'pricing.title': 'Çmimet',
  'pricing.subtitle': 'Zgjidhni planin që i përshtatet thellësisë së shqyrtimit tuaj.',
  'pricing.monthly': 'Mujore',
  'pricing.yearly': 'Vjetore',
  'pricing.yearlyDiscount': 'Abonimi vjetor:',
  'pricing.yearlyDiscountValue': '-20% zbritje',
  'pricing.perMonth': 'në muaj',
  'pricing.selectPlan': 'Zgjidh Planin',
  'pricing.mostPopular': 'Më i Popullarizuari',
  'pricing.footer': 'Të gjitha çmimet në CHF. Kreditë zbriten vetëm për përgjigje të suksesshme të AI.',

  
  // Pricing Features
  'pricing.feature1': 'Bisedë falas (pa formular)',
  'pricing.feature2': 'Logjika e tregut & vlerësim i sinqertë',
  'pricing.feature3': 'Histori e përhershme e bisedës',
  'pricing.feature4': 'Sesione të shumëfishta paralele të bisedës',
  'pricing.feature5': 'Plotësisht shumëgjuhësh',
  'pricing.feature6': 'Përdorim i bazuar në kredi',
  'pricing.feature7': 'Rivendosje mujore',
  'pricing.feature8': 'Analiza e tregut',
  'pricing.feature9': 'Përmbledhje',
  'pricing.feature10': 'Pikat e forta',
  'pricing.feature11': 'Dobësitë',
  'pricing.feature12': 'Mundësitë',
  'pricing.feature13': 'Rreziqet',
  'pricing.feature14': 'Rekomandime',
  'pricing.feature15': 'Shkarkoni PDF',
  'pricing.feature16': 'Pa informime për zhvilluesit',
  'pricing.feature17': 'Modaliteti i Ndërtuesit: Informime për zhvilluesit',
  'pricing.feature18': 'Përmbledhje e strukturuar',

  // Starter Plan
  'pricing.starter.name': 'Fillestar',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Qasje në chatbot-in AI për kamare',
  'pricing.starter.credits': '2,500 Kredi në muaj',
  'pricing.starter.feature1': 'Gjenero ide kamare',
  'pricing.starter.feature2': 'Përmirëso kamanë',
  'pricing.starter.feature3': 'Kontroll realiteti i tregut',
  'pricing.starter.feature4': 'Vlerësim i konkurrencës',
  'pricing.starter.feature5': 'Vlerësim i kohës',
  'pricing.starter.feature6': 'Verdikt i ndershëm',
  'pricing.starter.feature7': 'Sesione private',
  'pricing.starter.feature8': 'Histori dhe eksport',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Qasje në chatbot-in AI për kamare',
  'pricing.pro.credits': '5,000 Kredi në muaj',
  'pricing.pro.feature1': 'Të gjitha veçoritë e Starter',
  'pricing.pro.feature2': 'Më shumë kredi për shqyrtim intensiv',
  'pricing.pro.feature3': 'Sugjerime përmirësimi',
  'pricing.pro.feature4': 'Kamare alternative',
  'pricing.pro.feature5': 'Analizë e detajuar e tregut',
  'pricing.pro.feature6': 'Mbështetje prioritare',
  'pricing.pro.feature7': 'Filtra të avancuar',
  'pricing.pro.feature8': 'Sesione të preferuara',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Të gjitha veçoritë + modaliteti Builder",
  'pricing.builder.credits': "10.000 kredite në muaj",
  'pricing.builder.feature1': 'Të gjitha veçoritë e Pro',
  'pricing.builder.feature2': 'Kërkesa të pakufizuara AI',
  'pricing.builder.feature3': 'Modaliteti Ndërtues: Udhëzime për zhvillues',
  'pricing.builder.feature4': 'Përmbledhje e strukturuar e projektit',
  'pricing.builder.feature5': 'Rrjedha përdoruesi dhe veçori kryesore',
  'pricing.builder.feature6': 'Shënime teknike',
  'pricing.builder.feature7': 'Përcaktoni jo-qëllimet',
  'pricing.builder.feature8': 'Kufi i përdorimit të drejtë',
  'pricing.builder.limitNote': 'Kufi i përdorimit të drejtë',
  'pricing.monthlyReset': 'Rivendosje mujore',

  // Modal
  'pricing.modal.selected': 'përzgjedhur',
  'pricing.modal.comingSoon': 'Regjistrimi dhe përpunimi i pagesave do të jenë të disponueshëm së shpejti.',
  'pricing.modal.patience': 'Ne po punojmë për t\'ju ofruar një përvojë të sigurt dhe pa probleme. Ju lutemi të jeni të durueshëm.',
  'pricing.modal.understood': 'Kuptuar',

  // FAQ
  'faq.title': "Pyetje para se t'i besoni verdiktit",
  'faq.subtitle': 'Përgjigjur ndershëm & në mënyrë kritike.',
  'faq.q1': "Sa i sinqertë është realisht AI-ja?",
  'faq.a1': "Brutalisht. E kemi rregulluar të sinjalizojë ide të dobëta, tregje të mbingarkuara dhe shifra joreale. Nëse ideja juaj është e keqe, do t'jua thotë.",
  'faq.q2': "Çfarë marr me provën falas?",
  'faq.a2': "Verdikt të plotë, të gjitha metrikat, të gjitha rreziqet. Pa nevojë për kartë krediti. Raportet Builder (PDF-të 25–75 faqesh) kërkojnë një plan me pagesë.",
  'faq.q3': "Pse kredite në vend të përdorimit pa kufi?",
  'faq.a3': "Çdo verdikt zhvillon analizë reale me AI dhe kërkim në web. Kjo na kushton. Kreditet e mbajnë çmimin të drejtë — përdoruesit e rëndë paguajnë për atë që përdorin.",
  'faq.q4': "A mund t'u besoj të dhënave të tregut?",
  'faq.a4': "I marrim nga burime publike, faqe konkurrentësh dhe tendenca kërkimi. Citojmë aty ku është e mundur. Nuk shpikim shifra — nëse nuk e dimë, e themi.",
  'faq.q5': "Çfarë është një Builder Report?",
  'faq.a5': "Një PDF prej 25/50/75 faqesh (varësisht nga plani) me arkitekturë, stack teknologjik, model financiar, plan daljeje në treg dhe regjistër rreziqesh. Ndërtuar që t'ia dorëzoni një zhvilluesi ose investitori.",
  'faq.q6': "A mund të anuloj në çdo kohë?",
  'faq.a6': "Po. Pa kontrata afatgjata. Anuloni nga llogaria juaj. Mbani qasjen deri në fund të periudhës së paguar.",
  'faq.q7': "A i ruani idetë e mia?",
  'faq.a7': "Po — në llogarinë tuaj, që të mund t'i rishikoni. Nuk i shesim dhe nuk i ndajmë. Fshijini në çdo kohë.",
  'faq.q8': "Cilat gjuhë mbështeten?",
  'faq.a8': "Mbi njëzet. Verdikti përshtatet automatikisht me gjuhën tuaj.",
  'faq.q9': "A ka rimbursim?",
  'faq.a9': "Kthim parash brenda 7 ditësh për muajin tuaj të parë me pagesë nëse nuk keni përdorur ende Builder Reports.",
  'faq.q10': "Kush qëndron pas IdeaVerdict?",
  'faq.a10': "Një ekip i vogël zviceran që u lodh duke parë themelues që humbnin vite për ide që duhej të ishin vrarë në javën e parë.",
  // Footer
  'footer.description': 'IdeaVerdict nuk është këtu për të të bërë të ndihesh mirë. Është këtu për të të ndihmuar të vendosësh saktë.',
  'footer.product': 'Produkti',
  'footer.aiAssistant': 'Asistenti AI',
  'footer.howItWorks': 'Si funksionon',
  'footer.pricing': 'Çmimet',
  'footer.faq': 'Pyetjet e shpeshta',
  'footer.legal': 'Ligjore',
  'footer.privacy': 'Privatësia',
  'footer.terms': 'Kushtet',
  'footer.imprint': 'Gjurmë',
  'footer.support': 'Mbështetje',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentacioni',
  'footer.copyright': '© 2026 IdeaVerdict. Të gjitha të drejtat e rezervuara.',

  // AI Assistant
  'aiAssistant.title': 'Asistenti AI për Kamare',
  'aiAssistant.subtitle': 'Pyet rreth kamareve',
  'aiAssistant.welcomeMessage': 'Përshëndetje! Përshkruani idenë tuaj ose më pyesni për një kamare. Unë do t\'ju jap një vlerësim të qartë dhe të ndershëm.',
  'aiAssistant.demoResponse': 'Ky është një demo. Për të marrë vlerësime reale nga AI, ju lutemi regjistrohuni dhe zgjidhni një plan.',
  'aiAssistant.placeholder': 'Përshkruani idenë tuaj...',

  // Header & Sidebar
  'dashboard.header.title': 'Paneli',
  'dashboard.header.aiAssistant': 'Asistenti Juaj AI',
  'header.logout': 'Dilni',
  'dashboard.sidebar.overview': 'Përmbledhje',
  'dashboard.sidebar.aiChat': 'Asistenti AI',
  'dashboard.sidebar.newAnalysis': 'Asistenti AI',
  'dashboard.sidebar.history': 'Historia',
  'dashboard.sidebar.credits': 'Kreditë',
  'dashboard.sidebar.settings': 'Cilësimet',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Mirë se erdhët përsëri, {{name}}',
  'dashboard.overview.subtitle': 'Këtu është një përmbledhje e shpejtë e aktivitetit tuaj',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Kreditë e mbetura',
  'dashboard.stats.totalAnalyses': 'Analiza gjithsej',
  'dashboard.stats.goodRatings': 'Vlerësime pozitive',
  'dashboard.stats.nextReset': 'Rivendosja e radhës për',
  'dashboard.stats.days': 'ditë',

  // Quick Actions
  'dashboard.quickActions.title': 'Veprime të shpejta',
  'dashboard.quickActions.checkNewIdea': 'Kontrollo një ide',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analizo një ide ekzistuese biznesi',
  'dashboard.quickActions.generateIdea': 'Gjenero një ide',
  'dashboard.quickActions.generateIdeaDesc': 'Gjeni një kamare të re fitimprurëse',
  'dashboard.quickActions.builderBriefing': 'Udhëzim ndërtues',
  'dashboard.quickActions.builderBriefingDesc': 'Shndërroni një ide në një udhëzim të gatshëm për zhvillues',
  'dashboard.quickActions.premiumOnly': 'Vetëm për ndërtues',

  // Chat Header
  'chat.title': 'Asistenti AI për Kamare',
  'chat.subtitle': 'Bëni pyetje rreth kamareve. Unë vlerësoj në mënyrë kritike dhe të ndershme.',
  'chat.creditsLabel': 'Kreditë',

  // Chat Welcome
  'chat.welcomeTitle': 'Mirë se vini te Asistenti AI për Kamare',
  'chat.welcomeDesc': 'Përshkruani idenë tuaj ose pyesni për një kamare. Unë do ta vlerësoj atë ndershëm: Mirë, Mesatar ose Keq.',
  'chat.aiWelcome': 'Përshëndetje! Përshkruani idenë tuaj ose më pyesni për një kamare. Unë do t\'ju jap një vlerësim të qartë dhe të ndershëm.',

  // Chat Suggestions
  'chat.suggestion1': 'Dua të ndërtoj një mjet SaaS për frilancerët për të menaxhuar faturat. A është kjo kamare e mirë?',
  'chat.suggestion2': 'Gjejma një biznes online me konkurrencë të ulët që mund ta filloj me $500 pa njohuri programimi.',
  'chat.suggestion3': 'Vlerëso këtë: një aplikacion planifikimi ushqimesh me AI për prindër të zënë me kufizime dietike.',
  'chat.suggestion4': 'Dua të shes shabllone dixhitale në Etsy për pronarë biznesi të vogla. Analizo këtë kamare me ndershmëri.',

  // Chat Actions
  'chat.newConversation': 'Bisedë e re',
  'chat.today': 'Sot',
  'chat.yesterday': 'Dje',
  'chat.thisWeek': 'Këtë javë',
  'chat.thisMonth': 'Këtë muaj',
  'chat.older': 'Më të vjetra',
  'chat.messages': 'mesazhe',
  'chat.renameConversation': 'Riemërto',
  'chat.deleteConversation': 'Fshij',
  'chat.cancel': 'Anulo',
  'chat.rename': 'Riemërto',
  'chat.delete': 'Fshij',
  'chat.favorite': 'Shto te të preferuarat',
  'chat.unfavorite': 'Hiq nga të preferuarat',
  'chat.searchSessions': 'Kërko biseda...',
  'chat.noResults': 'Nuk u gjet asnjë rezultat',
  'chat.noSessions': 'Nuk ka ende biseda',
  'chat.enterNewName': 'Shkruani emrin e ri...',
  'chat.deleteConfirmMessage': 'Jeni i sigurt që dëshironi të fshini këtë bisedë? Ky veprim nuk mund të zhbëhet.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Shkruani pyetjen tuaj… (kushton 30 kredi)',
  'chat.send': 'Dërgo',
  'chat.voice': 'Fol',
  'chat.listeningPlaceholder': 'Po dëgjoj... Flisni tani.',
  'chat.stopListening': 'Ndalo dëgjimin',
  'chat.recording': 'Duke regjistruar...',
  'chat.speechNotSupported': 'Shfletuesi juaj nuk mbështet njohjen e zërit.',
  'chat.microphonePermissionDenied': 'Qasja në mikrofon u refuzua. Ju lutemi lejoni qasjen në cilësimet e shfletuesit.',
  'chat.errorNotEnoughCredits': 'Nuk keni kredi të mjaftueshme. Ju lutemi përmirësoni planin tuaj ose prisni rivendosjen e radhës.',
  'chat.errorAiFailed': 'Përgjigja e AI dështoi. Nuk u zbritën kredi.',
  'chat.errorRateLimit': 'Shumë kërkesa. Ju lutemi prisni një moment.',

  // Ratings
  'rating.good': 'Mirë',
  'rating.medium': 'Mesatar',
  'rating.bad': 'Keq',

  // Auth Page
  'auth.branding.headline1': 'Jo çdo ide është e mirë.',
  'auth.branding.headline2': 'Ne jua themi sinqerisht.',
  'auth.branding.subtitle': 'Një AI vendimmarrëse për kamare biznesi. E qartë. Kritike. Pa sheqerosje.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc': 'Idetë tuaja mbeten plotësisht private dhe të sigurta.',
  'auth.benefits.honest.title': 'AI i ndershëm',
  'auth.benefits.honest.desc': 'Pa sheqerosje – vetëm reagime të qarta dhe kritike.',
  'auth.benefits.fast.title': 'Rezultate të shpejta',
  'auth.benefits.fast.desc': 'Merrni qartësi për kamanë tuaj në minuta.',
  'auth.trust.users': 'Përdorues aktivë',
  'auth.trust.ideas': 'Ide të analizuara',
  'auth.trust.rating': 'Vlerësimi i përdoruesve',
  'auth.login.title': 'Hyrja',
  'auth.login.headline': 'Mirë se erdhët përsëri',
  'auth.login.subtitle': 'Hyni për të vazhduar udhëtimin tuaj.',
  'auth.login.forgotPassword': 'Keni harruar fjalëkalimin?',
  'auth.login.submit': 'Hyni',
  'auth.login.noAccount': 'Nuk keni llogari akoma?',
  'auth.login.signUp': 'Regjistrohu',
  'auth.register.title': 'Regjistrohu',
  'auth.register.headline': 'Krijoni llogarinë tuaj',
  'auth.register.subtitle': 'Filloni të analizoni idetë tuaja të biznesit sot.',
  'auth.register.submit': 'Krijo llogari',
  'auth.register.hasAccount': 'Keni tashmë një llogari?',
  'auth.register.signIn': 'Hyni',
  'auth.fields.name': 'Emri i plotë',
  'auth.fields.email': 'Adresa e emailit',
  'auth.fields.password': 'Fjalëkalimi',
  'auth.fields.confirmPassword': 'Konfirmo fjalëkalimin',
  'auth.fields.selectPlan': 'Zgjidhni planin tuaj',
  'auth.fields.testCode': 'Hyni dhe provoni falas',
  'auth.placeholders.name': 'Shkruani emrin tuaj',
  'auth.placeholders.email': 'Shkruani emailin tuaj',
  'auth.placeholders.password': 'Shkruani fjalëkalimin tuaj',
  'auth.placeholders.confirmPassword': 'Konfirmoni fjalëkalimin tuaj',
  'auth.placeholders.testCode': 'Shkruani kodin e testimit',
  'auth.terms.accept': 'Unë i pranoj',
  'auth.terms.terms': 'Kushtet dhe Rregullat',
  'auth.privacy.accept': 'Unë e pranoj',
  'auth.privacy.policy': 'Politikën e Privatësisë',
  'auth.errors.nameRequired': 'Emri kërkohet',
  'auth.errors.emailRequired': 'Emaili kërkohet',
  'auth.errors.emailInvalid': 'Ju lutemi shkruani një email të vlefshëm',
  'auth.errors.passwordRequired': 'Fjalëkalimi kërkohet',
  'auth.errors.passwordLength': 'Fjalëkalimi duhet të ketë të paktën 8 karaktere',
  'auth.errors.passwordMismatch': 'Fjalëkalimet nuk përputhen',
  'auth.errors.invalidCode': 'Kod i pavlefshëm ose i skaduar',
  'auth.errors.registrationCodeOnly': 'Ky kod është vetëm për regjistrim',
  'auth.errors.verificationFailed': 'Gabim gjatë verifikimit të kodit. Ju lutemi provoni përsëri.',
  'auth.loading': 'Ju lutemi prisni...',
  'auth.or': 'ose vazhdoni me',
  'auth.social.google': 'Vazhdo me Google',
  'auth.social.apple': 'Vazhdo me Apple',
  'auth.actions.verify': 'Verifiko',
  'auth.testCode.activated': 'Kodi i testimit u aktivizua!',
  'auth.testCode.days': 'ditë',
  'auth.testCode.months': 'muaj',
  'auth.testCode.freeAccess': 'qasje falas',
  'auth.testCode.credits': 'kredi',

  // Email Verification
  'auth.verification.title': 'Verifiko Emailin',
  'auth.verification.headline': 'Kontrolloni kutinë tuaj hyrëse',
  'auth.verification.subtitle': 'Ne dërguam një kod verifikimi në:',
  'auth.verification.codeLabel': 'Kodi i Verifikimit',
  'auth.verification.codePlaceholder': 'Shkruani kodin 6-shifror',
  'auth.verification.submit': 'Verifiko Emailin',
  'auth.verification.resend': 'Ridërgo kodin',
  'auth.verification.resendIn': 'Ridërgo në',
  'auth.verification.seconds': 'sekonda',
  'auth.verification.success': 'Emaili u verifikua me sukses!',
  'auth.verification.error': 'Kod i pavlefshëm. Ju lutemi provoni përsëri.',
  'auth.verification.expired': 'Kodi skadoi. Ju lutemi kërkoni një të ri.',
  'auth.verification.sent': 'Kodi i ri u dërgua!',
  'auth.verification.checkSpam': 'Nuk e morët? Kontrolloni dosjen e spam-it.',

  // Forgot Password
  'auth.forgot.title': 'Fjalëkalimi i harruar',
  'auth.forgot.headline': 'Rivendosni fjalëkalimin tuaj',
  'auth.forgot.subtitle': 'Shkruani adresën tuaj të emailit dhe ne do t\'ju dërgojmë një lidhje për rivendosje.',
  'auth.forgot.submit': 'Dërgo lidhjen për rivendosje',
  'auth.forgot.backToLogin': 'Kthehu te hyrja',
  'auth.forgot.success': 'Emaili u dërgua!',
  'auth.forgot.successMessage': 'Ne ju dërguam një email me udhëzime për të rivendosur fjalëkalimin tuaj.',
  'auth.forgot.checkInbox': 'Kontrolloni kutinë tuaj hyrëse',

  // Reset Password
  'auth.reset.title': 'Fjalëkalim i ri',
  'auth.reset.headline': 'Vendosni fjalëkalimin e ri',
  'auth.reset.subtitle': 'Shkruani fjalëkalimin tuaj të ri.',
  'auth.reset.newPassword': 'Fjalëkalimi i ri',
  'auth.reset.confirmNewPassword': 'Konfirmo fjalëkalimin e ri',
  'auth.reset.submit': 'Ndrysho fjalëkalimin',
  'auth.reset.success': 'Fjalëkalimi u ndryshua me sukses!',
  'auth.reset.successMessage': 'Tani mund të hyni me fjalëkalimin tuaj të ri.',
  'auth.reset.loginNow': 'Hyni tani',

  // Legal Pages
  'legal.backToAuth': 'Kthehu te hyrja',
  'legal.allRightsReserved': 'Të gjitha të drejtat e rezervuara.',

  // Terms Page
  'legal.terms.title': 'Kushtet dhe Rregullat',
  'legal.terms.lastUpdated': 'Përditësuar së fundmi',
  'legal.terms.section1.title': '1. Fushëveprimi',
  'legal.terms.section1.content': 'Këto Kushte dhe Rregulla zbatohen për të gjitha kontratat midis NicheFinder (në tekstin e mëtejmë "Ofruesi") dhe përdoruesit (në tekstin e mëtejmë "Klienti") në lidhje me përdorimin e platformës së analizës së kamareve të fuqizuar nga AI.',
  'legal.terms.section2.title': '2. Përshkrimi i Shërbimit',
  'legal.terms.section2.content': 'Ofruesi ofron një platformë të bazuar në AI që analizon dhe vlerëson idetë dhe kamaret e biznesit. Shërbimet përfshijnë:',
  'legal.terms.section2.item1': 'Analizë e fuqizuar nga AI e ideve të biznesit',
  'legal.terms.section2.item2': 'Vlerësim i potencialit të tregut dhe konkurrencës',
  'legal.terms.section2.item3': 'Gjenerim i sugjerimeve për kamare',
  'legal.terms.section2.item4': 'Krijim i udhëzimeve për zhvillues (paketa Ndërtues)',
  'legal.terms.section3.title': '3. Lidhja e Kontratës dhe Regjistrimi',
  'legal.terms.section3.content': 'Kontrata lidhet përmes regjistrimit në platformë dhe zgjedhjes së një pakete. Klienti konfirmon:',
  'legal.terms.section3.item1': 'Të jetë i rritur dhe plotësisht i aftë ligjërisht',
  'legal.terms.section3.item2': 'Të japë informacion të vërtetë gjatë regjistrimit',
  'legal.terms.section3.item3': 'Të ruajë në mënyrë të sigurt kredencialet e qasjes',
  'legal.terms.section4.title': '4. Kreditë dhe Faturimi',
  'legal.terms.section4.content': 'Përdorimi i veçorive të AI bazohet në një sistem kredish. Çdo pyetje e AI kushton 30 kredi. Kreditë zbriten vetëm pas përgjigjes së suksesshme. Kreditë e papërdorura skadojnë në fund të periudhës së faturimit dhe nuk rimbursohen.',
  'legal.terms.section5.title': '5. Heqja e Përgjegjësisë',
  'legal.terms.section5.content': 'Vlerësimet e AI shërbejnë vetëm si ndihmësa për vendimmarrje dhe nuk garantojnë sukses biznesi. Ofruesi nuk është përgjegjës për vendimet e marra bazuar në analizat e AI. Përgjegjësia për qëllim dhe neglizhencë të rëndë mbetet e pandikuar.',
  'legal.terms.section6.title': '6. Mbrojtja e të Dhënave dhe Konfidencialiteti',
  'legal.terms.section6.content': 'Të gjitha idetë e biznesit të paraqitura trajtohen në mënyrë konfidenciale dhe nuk ndahen me palë të treta. Përpunimi i të dhënave personale kryhet në përputhje me Politikën tonë të Privatësisë dhe ligjet e zbatueshme të mbrojtjes së të dhënave.',
  'legal.terms.section7.title': '7. Përfundimi',
  'legal.terms.section7.content': 'Klienti mund të anulojë abonimin e tij në çdo kohë në fund të periudhës aktuale të faturimit. Në rast shkeljesh të këtyre Kushteve, Ofruesi rezervon të drejtën të bllokojë qasjen në platformë.',
  'legal.terms.section8.title': '8. Dispozitat Përfundimtare',
  'legal.terms.section8.content': 'Zbatohet ligji zviceran. Vend i juridiksionit është Zyrihu, Zvicër. Nëse dispozitat individuale të këtyre Kushteve janë të pavlefshme, vlefshmëria e dispozitave të mbetura mbetet e pandikuar.',
  'legal.terms.contact.title': 'Pyetje rreth Kushteve?',
  'legal.terms.contact.content': 'Nëse keni pyetje rreth këtyre Kushteve dhe Rregullave, ju lutemi na kontaktoni në:',

  // Privacy Page
  'legal.privacy.title': 'Politika e Privatësisë',
  'legal.privacy.section1.title': '1. Kontrolluesi i të Dhënave',
  'legal.privacy.section1.content': 'Kontrolluesi i të dhënave për këtë faqe interneti është NicheFinder, Zyrihu, Zvicër. Ne e marrim shumë seriozisht mbrojtjen e të dhënave tuaja personale dhe i trajtojmë të dhënat tuaja personale në mënyrë konfidenciale dhe në përputhje me rregulloret ligjore të mbrojtjes së të dhënave.',
  'legal.privacy.section2.title': '2. Të Dhënat e Mbledhura',
  'legal.privacy.section2.content': 'Ne mbledhim dhe përpunojmë të dhënat e mëposhtme personale:',
  'legal.privacy.section2.item1': 'Të dhënat e regjistrimit: Emri, adresa e emailit, fjalëkalimi (i enkriptuar)',
  'legal.privacy.section2.item2': 'Të dhënat e përdorimit: Adresa IP, lloji i shfletuesit, kohët e qasjes',
  'legal.privacy.section2.item3': 'Idetë e biznesit dhe pyetjet e kamareve (të ruajtura në mënyrë anonime)',
  'legal.privacy.section2.item4': 'Informacioni i pagesës (përmes ofruesve të sigurt të palëve të treta)',
  'legal.privacy.section3.title': '3. Qëllimi i Përpunimit të të Dhënave',
  'legal.privacy.section3.content': 'Të dhënat tuaja përdoren për qëllimet e mëposhtme:',
  'legal.privacy.section3.item1': 'Ofrimi dhe përmirësimi i shërbimeve tona AI',
  'legal.privacy.section3.item2': 'Menaxhimi i llogarisë dhe vërtetimi',
  'legal.privacy.section3.item3': 'Faturimi dhe përpunimi i pagesave',
  'legal.privacy.section4.title': '4. Siguria e të Dhënave',
  'legal.privacy.section4.content': 'Ne zbatojmë masa sigurie teknike dhe organizative për të mbrojtur të dhënat tuaja kundër manipulimit, humbjes, shkatërrimit ose qasjes së paautorizuar. Të gjitha transferimet e të dhënave janë të enkriptuara përmes SSL/TLS.',
  'legal.privacy.section5.title': '5. Konfidencialiteti i Ideve Tuaja të Biznesit',
  'legal.privacy.section5.content': 'Idetë tuaja të biznesit dhe pyetjet e kamareve të paraqitura trajtohen rreptësisht konfidenciale. Ato nuk ndahen me palë të treta, nuk përdoren për qëllime trajnimi dhe mund të fshihen plotësisht me kërkesë. Idetë tuaja ju përkasin juve.',
  'legal.privacy.section6.title': '6. Të Drejtat Tuaja',
  'legal.privacy.section6.content': 'Ju keni të drejtat e mëposhtme në lidhje me të dhënat tuaja personale:',
  'legal.privacy.section6.item1': 'E drejta për të parë të dhënat e ruajtura',
  'legal.privacy.section6.item2': 'E drejta për korrigjimin e të dhënave të pasakta',
  'legal.privacy.section6.item3': 'E drejta për fshirjen e të dhënave tuaja',
  'legal.privacy.section6.item4': 'E drejta për portabilitetin e të dhënave',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content': 'Faqja jonë e internetit përdor vetëm cookie teknike të nevojshme për vërtetim dhe menaxhim seancash. Ne nuk përdorim cookie gjurmuese ose mjete analitike të palëve të treta pa pëlqimin tuaj të shprehur.',
  'legal.privacy.section8.title': '8. Ndryshimet në këtë Politikë të Privatësisë',
  'legal.privacy.section8.content': 'Ne rezervojmë të drejtën të përshtatim këtë politikë të privatësisë për të përmbushur kërkesat ligjore të ndryshuara ose kur ndodhin ndryshime në shërbim. Versioni aktual mund të gjendet gjithmonë në këtë faqe.',
  'legal.privacy.contact.title': 'Pyetje rreth Privatësisë?',
  'legal.privacy.contact.content': 'Nëse keni pyetje rreth përpunimit të të dhënave tuaja personale, ju lutemi na kontaktoni në:',

  'auth.passwordStrength.label': 'Forca e fjalëkalimit',
  'auth.passwordStrength.weak': 'I dobët',
  'auth.passwordStrength.medium': 'Mesatar',
  'auth.passwordStrength.strong': 'I fortë',
  'auth.passwordStrength.veryStrong': 'Shumë i fortë',
  'auth.passwordStrength.minLength': 'Min. 8 karaktere',
  'auth.passwordStrength.uppercase': 'Shkronjë e madhe',
  'auth.passwordStrength.number': 'Numër',
  'auth.passwordStrength.special': 'Karakter special',

  trial: {
    subtitle: 'Provë Falas',
    upgrade: 'Përmirëso Tani',
    creditsRemaining: 'kredi të mbetura',
    inputHint: 'Versioni provë - Asnjë histori bisede në dispozicion',
    banner: {
      title: 'Provë 7-Ditore Aktive',
      remaining: '{{days}} ditë të mbetura',
      credits: 'kredi të disponueshme',
      upgradeNow: 'Përmirëso Tani',
    },
    welcome: {
      title: 'Mirë se vini në Provën Falas!',
      desc: 'Testoni asistentin tonë AI falas për 7 ditë me 100 kredi. Bëni pyetje dhe zbuloni mundësitë!',
    },
    info: {
      title: 'Kufizimet e Provës',
      credits: '100 kredi për 7 ditë',
      noHistory: 'Asnjë histori bisede',
      noSettings: 'Veçori të kufizuara',
      upgrade: 'Përmirëso për veçori të plota',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Cilësimet',
  'settings.subtitle': 'Menaxhoni llogarinë dhe preferencat tuaja',
  'settings.backToOverview': 'Kthehu te përmbledhja',
  'settings.subscriptionLink': 'Abonimi dhe Faturimi',
  'settings.saved': 'Ndryshimet u ruajtën me sukses',
  'settings.changesSaved': 'Ndryshimet u ruajtën',
  'settings.saveChanges': 'Ruaj ndryshimet',
  'settings.dataExported': 'Të dhënat u eksportuan me sukses',

  // Tabs
  'settings.tabs.profile': 'Profili',
  'settings.tabs.preferences': 'Preferencat',
  'settings.tabs.notifications': 'Njoftimet',
  'settings.tabs.account': 'Llogaria dhe Plani',

  // Profile
  'settings.profile.changePhoto': 'Ndrysho foton',
  'settings.profile.photoHint': 'JPG, PNG ose GIF (max. 2MB)',
  'settings.profile.uploading': 'Duke ngarkuar...',
  'settings.profile.photoUpdated': 'Fotoja e profilit u përditësua!',
  'settings.profile.name': 'Emri',
  'settings.profile.email': 'Emaili',
  'settings.profile.phone': 'Telefoni',
  'settings.profile.changePassword': 'Ndrysho fjalëkalimin',
  'settings.profile.currentPassword': 'Fjalëkalimi aktual',
  'settings.profile.newPassword': 'Fjalëkalimi i ri',
  'settings.profile.confirmPassword': 'Konfirmo fjalëkalimin',

  // Preferences
  'settings.preferences.language': 'Gjuha',
  'settings.preferences.chooseLanguage': 'Zgjidh gjuhën',
  'settings.preferences.timezone': 'Zona kohore',
  'settings.preferences.currency': 'Valuta',

  // Notifications
  'settings.notifications.emailTitle': 'Njoftimet me Email',
  'settings.notifications.email.analysis': 'Analiza e përfunduar',
  'settings.notifications.email.analysisDesc': 'Merrni një email kur analiza juaj është gati',
  'settings.notifications.email.credits': 'Përditësimet e kredive',
  'settings.notifications.email.creditsDesc': 'Njoftime për kreditë dhe rivendosjet',
  'settings.notifications.email.billing': 'Faturat dhe Pagesat',
  'settings.notifications.email.billingDesc': 'Njoftime për faturat dhe ndryshimet e planit',
  'settings.notifications.email.newsletter': 'Gazeta',
  'settings.notifications.email.newsletterDesc': 'Këshilla, përditësime dhe veçori të reja',
  'settings.notifications.pushTitle': 'Njoftimet Shtytëse',
  'settings.notifications.push.analysis': 'Analiza e përfunduar',
  'settings.notifications.push.analysisDesc': 'Njoftim në shfletues kur analiza është gati',
  'settings.notifications.push.credits': 'Paralajmërime për kreditë',
  'settings.notifications.push.creditsDesc': 'Paralajmërim kur bilanci i kredive është i ulët',

  // Account
  'settings.account.currentSubscription': 'Abonimi Aktual',
  'settings.account.plan': 'Plani',
  'settings.account.price': 'Çmimi',
  'settings.account.nextBilling': 'Faturimi i radhës',
  'settings.account.manageSubscription': 'Menaxho abonimin dhe pagesat',
  'settings.account.dataPrivacy': 'Të Dhënat dhe Privatësia',
  'settings.account.exportData': 'Eksporto të dhënat',
  'settings.account.deleteAccount': 'Fshij llogarinë',

  // Delete Modal
  'settings.deleteModal.title': 'Të fshihet llogaria?',
  'settings.deleteModal.subtitle': 'Të gjitha të dhënat do të fshihen përgjithmonë.',
  'settings.deleteModal.warning1': 'Të gjitha analizat dhe të dhënat do të fshihen',
  'settings.deleteModal.warning2': 'Abonimi aktiv do të anulohet menjëherë',
  'settings.deleteModal.warning3': 'Asnjë rimbursim i mundshëm',
  'settings.deleteModal.confirmLabel': 'Shkruani "{{word}}" për të konfirmuar *',
  'settings.deleteModal.cancel': 'Anulo',
  'settings.deleteModal.confirm': 'Fshij llogarinë',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Kthehu te përmbledhja',
  'sub.settings': 'Cilësimet',
  'sub.title': 'Abonimi dhe Faturimi',
  'sub.subtitle': 'Menaxhoni abonimin tuaj, metodat e pagesës dhe faturat',
  'sub.tab.overview': 'Përmbledhje',
  'sub.tab.payment': 'Metodat e Pagesës',
  'sub.tab.billing': 'Adresa e Faturimit',
  'sub.tab.history': 'Historiku i Pagesave',
  'sub.memberSince': 'Anëtar që nga',
  'sub.perMonth': 'në muaj',
  'sub.baseCHF': '(CHF {{amount}} bazë)',
  'sub.nextBilling': 'Faturimi i radhës',
  'sub.creditsUsed': 'Kreditë e përdorura',
  'sub.paymentMethod': 'Metoda e pagesës',
  'sub.creditUsage': 'Përdorimi i kredive',
  'sub.changePlan': 'Ndrysho planin',
  'sub.reactivate': 'Riaktivizo',
  'sub.cancelSub': 'Anulo abonimin',
  'sub.manageCards': 'Menaxho kartat',
  'sub.downloadInvoices': 'Shkarko faturat',
  'sub.invoicesAvailable': '{{count}} fatura të disponueshme si PDF',
  'sub.accountSettings': 'Cilësimet e Llogarisë',
  'sub.profileNotifications': 'Profili, njoftimet dhe më shumë',
  // Prices in EUR info
  'sub.eurInfo': 'Çmimet e treguara në',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Norma:',
  'sub.currentRate': 'Norma aktuale',
  // Payment Methods
  'sub.savedCards': 'Kartat e Ruajtura',
  'sub.newCard': 'Kartë e Re',
  'sub.default': 'Parazgjedhur',
  'sub.setDefault': 'Vendos si parazgjedhur',
  'sub.validUntil': 'E vlefshme deri më',
  'sub.noCards': 'Nuk ka karta të ruajtura',
  'sub.addFirstCard': 'Shto kartën e parë',
  'sub.securePayments': 'Pagesa të Sigurta',
  'sub.securePaymentsDesc': 'Të gjitha të dhënat e pagesës transmetohen të enkriptuara dhe ruhen në mënyrë të sigurt me ofruesin tonë të pagesave. Ne nuk ruajmë numra të plotë të kartave.',
  // Billing Address
  'sub.billingAddress': 'Adresa e Faturimit',
  'sub.edit': 'Ndrysho',
  'sub.name': 'Emri',
  'sub.streetAddress': 'Rruga dhe Numri',
  'sub.zip': 'Kodi Postar',
  'sub.city': 'Qyteti',
  'sub.country': 'Shteti',
  'sub.address': 'Adresa',
  'sub.save': 'Ruaj',
  'sub.cancel': 'Anulo',
  'sub.country.switzerland': 'Zvicër',
  'sub.country.germany': 'Gjermani',
  'sub.country.austria': 'Austri',
  'sub.country.netherlands': 'Holandë',
  'sub.country.belgium': 'Belgjikë',
  // Payment History
  'sub.paymentHistory': 'Historiku i Pagesave',
  'sub.allInvoicesPDF': 'Shkarko të gjitha faturat si PDF me logo',
  'sub.downloadAll': 'Shkarko të gjitha',
  'sub.eurInvoiceNote': 'Faturat lëshohen gjithmonë në CHF. Shumat e shfaqura në EUR janë vetëm për referencë.',
  'sub.date': 'Data',
  'sub.description': 'Përshkrimi',
  'sub.net': 'Neto',
  'sub.vat': 'TVSH',
  'sub.total': 'Gjithsej',
  'sub.status': 'Statusi',
  'sub.pdf': 'PDF',
  'sub.invoices': 'fatura',
  'sub.totalAmount': 'Shuma totale',
  // Change Plan Modal
  'sub.changePlanTitle': 'Ndrysho Planin',
  'sub.current': 'Aktual',
  'sub.month': '/muaj',
  'sub.showLess': 'Trego më pak',
  'sub.showMore': '+{{count}} më shumë',
  'sub.switchPlan': 'Ndrysho planin',
  'sub.eurPriceNote': 'Çmimet e treguara në EUR ({{note}}). Faturimi është në CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Të anulohet vërtet abonimi?',
  'sub.cancelIrreversible': 'Ky veprim nuk mund të zhbëhet.',
  'sub.cancelWarning1': 'Të gjitha kreditë e mbetura do të skadojnë',
  'sub.cancelWarning2': 'Zbritje në Planin Falas',
  'sub.cancelWarning3': 'Humbje e të gjitha veçorive premium',
  'sub.pauseInstead': 'Alternativisht: Të pezullohet abonimi?',
  'sub.pauseDesc': 'Pezulloni abonimin tuaj dhe mbani të dhënat tuaja.',
  'sub.preferPause': 'Preferoj të pezulloj',
  'sub.cancelReason': 'Arsyeja e anulimit',
  'sub.selectReason': 'Ju lutemi zgjidhni...',
  'sub.reason.tooExpensive': 'Shumë i shtrenjtë',
  'sub.reason.notUsing': 'Nuk po e përdor mjaftueshëm',
  'sub.reason.missingFeatures': 'Mungojnë veçoritë',
  'sub.reason.foundAlternative': 'Gjeta një alternativë',
  'sub.reason.other': 'Tjetër',
  'sub.confirmType': 'Konfirmimi: Shkruani "CANCEL" *',
  'sub.cancelNow': 'Anulo tani',
  // Add Card Modal
  'sub.addCardTitle': 'Shto Kartë të Re',
  'sub.cardHolder': 'Mbajtësi i Kartës *',
  'sub.cardNumber': 'Numri i Kartës *',
  'sub.expiryDate': 'Data e Skadencës *',
  'sub.addCard': 'Shto kartën',
  // Change Card Modal
  'sub.choosePayment': 'Zgjidh metodën e pagesës',
  'sub.active': 'Aktiv',
  'sub.close': 'Mbyll',
  // Toast messages
  'sub.toast.cancelled': 'Abonimi juaj është anuluar në fund të periudhës së faturimit.',
  'sub.toast.reactivated': 'Abonimi juaj u riaktivizua me sukses!',
  'sub.toast.planChanged': 'Plani u ndryshua me sukses në {{plan}}!',
  'sub.toast.defaultChanged': 'Metoda e parazgjedhur e pagesës u ndryshua.',
  'sub.toast.cannotDeleteDefault': 'Karta e parazgjedhur nuk mund të fshihet.',
  'sub.toast.cardRemoved': 'Karta është hequr.',
  'sub.toast.fillAll': 'Ju lutemi plotësoni të gjitha fushat.',
  'sub.toast.cardAdded': 'Karta e re u shtua me sukses!',
  'sub.toast.billingSaved': 'Adresa e faturimit u ruajt.',
  'sub.toast.invoiceDownloaded': 'Fatura {{id}} u shkarkua!',
  'sub.toast.pdfError': 'Gabim gjatë krijimit të PDF-së.',
  // Chat interface
  'sub.notEnoughCredits': 'Nuk keni kredi të mjaftueshme',
  'sub.needCredits': 'Ju nevojiten të paktën {{count}} kredi për pyetje.',
  'sub.creditsLow': 'Kreditë po mbarojnë',
  'sub.questionsLeft': '{{count}} pyetje të mundshme.',
  'sub.plan': 'Plani',
  'sub.base': 'bazë',
  'sub.unlimited': 'E pakufizuar',
  'sub.status.active': 'Aktiv',
  'sub.status.cancelled': 'Anuluar',
  'sub.status.paused': 'Pezulluar',
  'sub.invoice': 'FATURA',
  'sub.from': 'NGA',
  'sub.to': 'TE',
  'sub.vatId': 'Numri i TVSH-së',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Data e faturës',
  'sub.invoiceNumber': 'Numri i faturës',
  'sub.paymentStatus': 'Statusi i pagesës',
  'sub.creditCard': 'Karta e kreditit',
  'sub.quantity': 'SASIA',
  'sub.price': 'ÇMIMI',
  'sub.amount': 'SHUMA',
  'sub.subtotal': 'Nëntotali',
  'sub.bank': 'Banka',
  'sub.card': 'Karta',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Paneli i Administratorit',
  'admin.subtitle': 'Qendra e Kontrollit',
  'admin.superAdmin': 'Super Administrator',
  'admin.logout': 'Dilni',
  'admin.tabs.users': 'Menaxhimi i Përdoruesve',
  'admin.tabs.downgrades': 'Zbritjet',
  'admin.tabs.tips': 'Këshilla e Ditës',
  'admin.tabs.coupons': 'Kodet e Kuponëve',
  'admin.tabs.website': 'Redaktuesi i Faqes',
  'admin.tabs.ai': 'Cilësimet e AI',
  'admin.tabs.transactions': 'Regjistri i Transaksioneve',
  'admin.tabs.stats': 'Statistikat',
  'admin.users.searchPlaceholder': 'Kërko përdorues (email ose emër)...',
  'admin.users.manageSubscription': 'Menaxho abonimin',
  'admin.users.grantFree': 'Jep llogari falas',
  'admin.users.blockUser': 'Blloko përdoruesin',
  'admin.users.cancellationPlaceholder': 'Pse po anulohet abonimi?',
  'admin.users.selectPlan': 'Zgjidh planin',
  'admin.users.subChanged': 'Abonimi i {{name}} u ndryshua në {{plan}}',
  'admin.users.noReasonGiven': 'Nuk është dhënë asnjë arsye',
  'admin.users.subCancelled': 'Abonimi i {{name}} u anulua (i vlefshëm deri më {{date}})',
  'admin.users.paused': 'Pezulluar',
  'admin.users.subPaused': 'Abonimi i {{name}} është pezulluar',
  'admin.users.subReactivated': 'Abonimi i {{name}} është riaktivizuar',
  'admin.users.freeAccount': 'Llogari Falas',
  'admin.users.blocked': 'I bllokuar',
  'admin.users.cancelledExpiring': 'Anuluar (skadon)',
  'admin.users.cancelledOn': 'Anuluar më:',
  'admin.users.endsOn': 'Përfundon më:',
  'admin.users.daysRemaining': 'ditë të mbetura',
  'admin.users.expired': '(Skaduar)',
  'admin.users.total': 'Gjithsej:',
  'admin.users.usersLabel': 'përdorues',
  'admin.users.free': 'falas',
  'admin.users.block': 'Blloko',
  'admin.users.unblock': 'Zhblloko',
  'admin.users.unblockUser': 'Zhblloko përdoruesin',
  'admin.users.selectAction': 'Zgjidh veprimin',
  'admin.users.cancelSub': 'Anulo abonimin',
  'admin.users.cancelSubDesc': 'Anulim në fund të muajit',
  'admin.users.pauseSub': 'Pezullo abonimin',
  'admin.users.pauseSubDesc': 'Pezullim i përkohshëm',
  'admin.users.changePlan': 'Ndrysho planin',
  'admin.users.changePlanDesc': 'Kalo në një plan tjetër',
  'admin.users.reactivateSub': 'Riakrivizo abonimin',
  'admin.users.reactivateDesc': 'Zhbëj anulimin',
  'admin.users.alreadyCancelled': 'Abonimi tashmë i anuluar',
  'admin.users.planLabel': 'Plani',
  'admin.users.cancellationReasonOpt': 'Arsyeja e anulimit (opsionale)',
  'admin.users.cancelInfo1': 'Abonimi do të përfundojë më',
  'admin.users.cancelInfo2': '(fundi i muajit). Deri atëherë përdoruesi ka qasje të plotë. Asnjë rimbursim.',
  'admin.users.newPlan': 'Plani i ri',
  'admin.users.warning': 'Paralajmërim',
  'admin.users.blockDesc': 'Përdoruesi do të dalë menjëherë dhe nuk mund të hyjë më. Të gjitha sesionet aktive do të përfundojnë.',
  'admin.users.confirmUnblock': 'Konfirmo zhbllokimin',
  'admin.users.unblockDesc': 'Përdoruesi mund të hyjë përsëri dhe të përdorë të gjitha veçoritë.',
  'admin.users.afterBlock': 'Pas bllokimit:',
  'admin.users.afterUnblock': 'Pas zhbllokimit:',
  'admin.users.noAccountAccess': 'Asnjë qasje në llogari',
  'admin.users.noNewAnalyses': 'Asnjë analizë e re e mundshme',
  'admin.users.creditsStored': 'Kreditë dhe historia mbeten të ruajtura',
  'admin.users.accessRestored': 'Qasja në llogari u rivendos',
  'admin.users.allFeaturesAvail': 'Të gjitha veçoritë janë përsëri të disponueshme',
  'admin.users.creditsPreserved': 'Kreditë dhe historia u ruajtën',
  'admin.users.downgrade': 'Zbritja e Planit',
  'admin.users.grantFreeBtn': 'Jep falas',
  'admin.users.durationMonths': 'Kohëzgjatja (muaj)',
  'admin.users.months': 'muaj',
  'admin.users.freePlan': 'falas',
  'admin.users.freeSummary': 'merr',
  'admin.users.withCredits': 'me',
  'admin.users.credits': 'Kredi',
  'admin.users.subInfo': 'Informacioni i Abonimit',
  'admin.users.currentPlan': 'Plani Aktual',
  'admin.users.joined': 'U bashkua më',
  'admin.users.totalSpent': 'Shpenzimet Totale',
  'admin.users.paymentMethod': 'Metoda e Pagesës',
  'admin.users.validThrough': 'E vlefshme deri më',
  'admin.users.billingAddress': 'Adresa e Faturimit',
  'admin.users.transactionHistory': 'Historiku i Transaksioneve',
  'admin.users.cancellationDate': 'Data e anulimit',
  'admin.users.validUntil': 'E vlefshme deri më (fundi i muajit)',
  'admin.users.cancellationReason': 'Arsyeja e anulimit',
  'admin.users.noReason': 'Nuk është dhënë asnjë arsye',
  'admin.users.timeRemaining': 'Koha e mbetur',
  'admin.users.daysUntilDeactivation': 'ditë deri në çaktivizim',
  'admin.table.user': 'Përdoruesi',
  'admin.table.plan': 'Plani',
  'admin.table.subStatus': 'Statusi i Abonimit',
  'admin.table.cancellation': 'Anulimi',
  'admin.table.payment': 'Metoda e Pagesës',
  'admin.table.spending': 'Shpenzimet',
  'admin.table.actions': 'Veprimet',
  'admin.actions.viewDetails': 'Shiko detajet',
  'admin.actions.manageSubscription': 'Menaxho abonimin',
  'admin.actions.grantFree': 'Jep qasje falas',
  'admin.actions.block': 'Blloko përdoruesin',
  'admin.actions.unblock': 'Zhblloko përdoruesin',
  'admin.actions.cancel': 'Anulo',
  'admin.actions.save': 'Ruaj',
  'admin.actions.delete': 'Fshij',
  'admin.actions.confirm': 'Konfirmo',
  'admin.actions.done': 'U krye',
  'admin.actions.edit': 'Ndrysho',
  'admin.actions.close': 'Mbyll',
  'admin.table.status': 'Statusi',
  'admin.filter.all': 'Të gjithë',
  'admin.subscription.active': 'Aktiv',
  'admin.subscription.cancelled': 'Anuluar',
  'admin.subscription.paused': 'Pezulluar',
  'admin.subscription.unknown': 'I panjohur',
  'admin.status.active': 'Aktiv',
  'admin.status.inactive': 'Joaktiv',
  'admin.status.pending': 'Në pritje',
  'admin.status.approved': 'I miratuar',
  'admin.status.rejected': 'I refuzuar',
  'admin.coupons.title': 'Menaxhimi i Kuponëve',
  'admin.coupons.subtitle': 'Krijoni dhe menaxhoni kodet e kuponëve',
  'admin.coupons.newCoupon': 'Kupon i Ri',
  'admin.coupons.registrationCoupons': 'Kuponët e Regjistrimit',
  'admin.coupons.trialCoupons': 'Kuponët e Qasjes Provë',
  'admin.coupons.type': 'Lloji',
  'admin.coupons.plan': 'Plani',
  'admin.coupons.value': 'Vlera',
  'admin.coupons.usage': 'Përdorimi',
  'admin.coupons.validUntil': 'E Vlefshme Deri më',
  'admin.coupons.created': 'Krijuar më',
  'admin.coupons.actions': 'Veprimet',
  'admin.coupons.copyCode': 'Kopjo kodin',
  'admin.coupons.allPlans': 'Të gjitha Planet',
  'admin.coupons.discount': 'Zbritja',
  'admin.coupons.days': 'ditë',
  'admin.coupons.months': 'muaj',
  'admin.coupons.free': 'falas',
  'admin.coupons.unlimited': 'E pakufizuar',
  'admin.coupons.createRegistration': 'Krijo Kupon Regjistrimi',
  'admin.coupons.createTrial': 'Krijo Kupon Qasjeje Provë',
  'admin.coupons.couponCode': 'Kodi i Kuponit',
  'admin.coupons.codePlaceholder': 'p.sh. NF-7X3K9M',
  'admin.coupons.generateCode': 'Gjenero kod të ri',
  'admin.coupons.alertFillRequired': 'Ju lutemi plotësoni të gjitha fushat e kërkuara',
  'admin.coupons.alertSelectExpiry': 'Ju lutemi zgjidhni një datë skadence ose aktivizoni "Vlefshmëri e pakufizuar"',
  'admin.coupons.alertCreateError': 'Gabim gjatë krijimit të kuponit',
  'admin.coupons.confirmDelete': 'Jeni i sigurt që dëshironi të fshini këtë kupon?',
  'admin.coupons.discountPercent': 'Zbritja (%)',
  'admin.coupons.bonusCredits': 'Kredi Bonus',
  'admin.coupons.freeDuration': 'Kohëzgjatja Falas',
  'admin.coupons.maxUses': 'Përdorimet Maksimale',
  'admin.coupons.expiryDate': 'Data e Skadencës',
  'admin.coupons.unlimitedValidity': 'Vlefshmëri e pakufizuar',
  'admin.coupons.unlimitedUses': 'Përdorime të pakufizuara',
  'admin.coupons.trialCredits': 'Kreditë e Provës',
  'admin.coupons.trialDuration': 'Kohëzgjatja e Provës',
  'admin.coupons.typePlaceholder': 'p.sh. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Kohëzgjatja',
  'admin.stats.totalUsers': 'Përdoruesit Total',
  'admin.stats.monthlyRevenue': 'Të Ardhurat Mujore',
  'admin.stats.activeSubscriptions': 'Abonimet Aktive',
  'admin.stats.average': 'Mesatarja',
  'admin.stats.revenuePerUser': 'Të Ardhurat për Përdorues',
  'admin.stats.grossRevenue': 'Të Ardhurat Bruto',
  'admin.stats.net': 'NETO',
  'admin.stats.netRevenue': 'Të Ardhurat Neto',
  'admin.stats.churnRate': 'Norma e Braktisjes',
  'admin.stats.planDistribution': 'Shpërndarja e Planeve',
  'admin.stats.users': 'përdorues',
  'admin.stats.revenueByPlan': 'Të Ardhurat sipas Planit',
  'admin.stats.recentActivity': 'Aktiviteti i Fundit',
  'admin.stats.activity1': 'Thomas Weber përmirësoi në Builder',
  'admin.stats.activity2': 'Përdorues i ri u regjistrua',
  'admin.stats.activity3': 'Anna Schmidt përmirësoi në Pro',
  'admin.stats.hoursAgo2': '2 orë më parë',
  'admin.stats.hoursAgo5': '5 orë më parë',
  'admin.stats.dayAgo1': '1 ditë më parë',
  'admin.stats.couponStats': 'Statistikat e Kuponëve',
  'admin.stats.totalRedemptions': 'Shlyerjet Totale',
  'admin.stats.activeCoupons': 'Kuponët Aktivë',
  'admin.stats.registrationRedemptions': 'Shlyerjet e Regjistrimit',
  'admin.stats.trialRedemptions': 'Shlyerjet e Provës',
  'admin.stats.couponDistribution': 'Shpërndarja e Kuponëve',
  'admin.stats.registrationCoupons': 'Kuponët e Regjistrimit',
  'admin.stats.trialCoupons': 'Kuponët e Provës',
  'admin.stats.expiredInactive': 'Të Skaduara/Joaktive',
  'admin.stats.topCoupons': 'Kuponët Kryesorë sipas Shlyerjeve',
  'admin.stats.redemptions': 'shlyerje',
  'admin.stats.noCouponsRedeemed': 'Nuk është shlyer asnjë kupon ende',
  'admin.downgrade.pending': 'në pritje',
  'admin.downgrade.refunds': 'Rimbursimet',
  'admin.downgrade.sectionRequests': 'Kërkesat',
  'admin.downgrade.sectionStats': 'Statistikat',
  'admin.downgrade.sectionRules': 'Rregullat',
  'admin.downgrade.pendingRequests': 'Kërkesat në Pritje',
  'admin.downgrade.approvedRequests': 'Kërkesat e Miratuara',
  'admin.downgrade.rejectedRequests': 'Kërkesat e Refuzuara',
  'admin.downgrade.activeRules': 'Rregullat Aktive',
  'admin.downgrade.autoRules': 'Rregullat e Zbritjes Automatike',
  'admin.downgrade.autoRulesDesc': 'Krijoni rregulla që shkaktojnë automatikisht zbritje bazuar në sjelljen e përdorimit',
  'admin.downgrade.newRule': 'Rregull i Ri',
  'admin.downgrade.totalRules': 'Rregullat Totale',
  'admin.downgrade.triggeredActions': 'Veprimet e Shkaktuara',
  'admin.downgrade.conditionsAnd': 'Kushtet (të lidhura me DHE)',
  'admin.downgrade.action': 'Veprimi',
  'admin.downgrade.successTitle': 'Zbritja e suksesshme!',
  'admin.downgrade.successDesc': 'Përdoruesi është zbritur me sukses dhe rimbursimi është përpunuar.',
  'admin.downgrade.closing': 'Po mbyllet...',
  'admin.downgrade.title': 'Zbritja e Përdoruesit',
  'admin.downgrade.currentPlan': 'Plani Aktual',
  'admin.downgrade.spending': 'Shpenzimet',
  'admin.downgrade.availablePlans': 'Planet e Disponueshme për Zbritje',
  'admin.downgrade.perMonth': 'në muaj',
  'admin.downgrade.refundCalc': 'Llogaritja e Rimbursimit',
  'admin.downgrade.currentPlanLabel': 'Plani Aktual',
  'admin.downgrade.newPlan': 'Plani i Ri',
  'admin.downgrade.remainingDays': 'Ditët e Mbetura',
  'admin.downgrade.daysOf': '15 nga 30 ditë',
  'admin.downgrade.proRataRefund': 'Rimbursimi Pro-rata',
  'admin.downgrade.importantNote': 'Shënim i Rëndësishëm',
  'admin.downgrade.warningDesc': 'Zbritja do të ekzekutohet menjëherë. Përdoruesi do të humbasë qasjen në veçoritë premium dhe kreditë e tepërta do të hiqen.',
  'admin.downgrade.processing': 'Duke përpunuar...',
  'admin.downgrade.execute': 'Ekzekuto Zbritjen',
  'admin.downgrade.notification': 'Njoftimi',
  'admin.downgrade.noNotification': 'Pa Njoftim',
  'admin.downgrade.daysPeriod': 'ditë periudhë pritjeje',
  'admin.downgrade.created': 'Krijuar më:',
  'admin.downgrade.triggered': 'shkaktuar',
  'admin.downgrade.noRules': 'Nuk është krijuar asnjë rregull ende',
  'admin.downgrade.createFirstRule': 'Krijo rregullin e parë',
  'admin.downgrade.editRule': 'Ndrysho Rregullin',
  'admin.downgrade.createRule': 'Krijo Rregull të Ri',
  'admin.downgrade.ruleName': 'Emri i rregullit',
  'admin.downgrade.description': 'Përshkrimi',
  'admin.downgrade.allConditions': 'Kushtet (të gjitha duhet të plotësohen)',
  'admin.downgrade.addCondition': 'Shto kusht',
  'admin.downgrade.type': 'Lloji',
  'admin.downgrade.value': 'Vlera',
  'admin.downgrade.fromPlan': 'Nga plani',
  'admin.downgrade.toPlan': 'Në planin',
  'admin.condition.inactivity': 'Pasiviteti',
  'admin.condition.creditUsage': 'Përdorimi i Kredive',
  'admin.condition.loginFrequency': 'Frekuenca e Hyrjes',
  'admin.condition.featureUsage': 'Përdorimi i Veçorive',
  'admin.condition.supportTickets': 'Kërkesat e Mbështetjes',
  'admin.operator.lessThan': 'më pak se',
  'admin.operator.greaterThan': 'më shumë se',
  'admin.operator.equals': 'saktësisht',
  'admin.operator.between': 'midis',
  'admin.unit.days': 'ditë',
  'admin.unit.perMonth': 'në muaj',
  'admin.unit.count': 'numri',
  'admin.transactions.all': 'Të gjitha Transaksionet',
  'admin.transactions.allCards': 'Të gjitha Kartat',
  'admin.transactions.notFound': 'Nuk u gjetën transaksione',
  'admin.transactions.totalLabel': 'Gjithsej',
  'admin.transactions.transactions': 'transaksione',
  'admin.tips.title': 'Këshilla e Ditës',
  'admin.tips.subtitle': 'Krijoni dhe menaxhoni këshilla të shfaqura për të gjithë përdoruesit',
  'admin.tips.active': 'Aktiv',
  'admin.tips.currentlyShown': 'Kjo këshillë po u shfaqet të gjithë përdoruesve',
  'admin.tips.createNew': 'Krijo Këshillë të Re',
  'admin.tips.generating': 'Duke gjeneruar...',
  'admin.tips.generateAI': 'Gjenero Këshillë me AI',
  'admin.tips.titleLabel': 'Titulli',
  'admin.tips.titlePlaceholder': 'p.sh. Këshilla e Ditës',
  'admin.tips.category': 'Kategoria',
  'admin.tips.categoryTip': 'Këshillë',
  'admin.tips.categoryFeature': 'Veçori e Re',
  'admin.tips.categoryProductivity': 'Produktivitet',
  'admin.tips.categoryUpdate': 'Përditësim',
  'admin.tips.content': 'Përmbajtja',
  'admin.tips.contentPlaceholder': 'Shkruani këshillën tuaj për përdoruesit këtu...',
  'admin.tips.addTip': 'Shto Këshillë',
  'admin.tips.allTips': 'Të Gjitha Këshillat',
  'admin.tips.noTips': 'Nuk është krijuar asnjë këshillë ende',
  'admin.tips.noTipsHint': 'Klikoni "Gjenero Këshillë me AI" për të filluar',
  'admin.noData': 'Nuk ka të dhëna të disponueshme',
  'admin.range.7d': '7 ditë',
  'admin.range.30d': '30 ditë',
  'admin.range.90d': '90 ditë',
  'admin.range.1y': '1 vit',
  'admin.actions.saveSettings': 'Ruaj cilësimet',
  'admin.actions.create': 'Krijo',
  'admin.downgrade.sectionReports': 'Raportet',
  'admin.downgrade.settings': 'Cilësimet e Zbritjes',
  'admin.downgrade.autoApprove': 'Miratim Automatik',
  'admin.downgrade.autoApproveDesc': 'Mirato automatikisht kërkesat për zbritje',
  'admin.downgrade.refundPolicy': 'Politika e Rimbursimit',
  'admin.downgrade.prorata': 'Rimbursim proporcional',
  'admin.downgrade.prorataDesc': 'Rimbursim proporcional bazuar në ditët e mbetura',
  'admin.downgrade.fullRefund': 'Rimbursim i plotë',
  'admin.downgrade.fullRefundDesc': 'Rimbursim i plotë i diferencës së çmimit',
  'admin.downgrade.noRefund': 'Pa rimbursim',
  'admin.downgrade.noRefundDesc': 'Zbritje pa rimbursim',
  'admin.downgrade.daysRemaining15': '(me 15 ditë të mbetura)',
  'admin.downgrade.requestsTitle': 'Kërkesat për Zbritje',
  'admin.downgrade.approvalRate': 'Norma e miratimit',
  'admin.downgrade.mostCommonTransition': 'Tranzicioni më i zakonshëm',
  'admin.downgrade.mostCommonReason': 'Arsyeja më e zakonshme',
  'admin.downgrade.avgProcessingTime': 'Koha mesatare e përpunimit',
  'admin.downgrade.avgTimeDesc': 'Koha mesatare deri në vendim',
  'admin.downgrade.totalRefunds': 'Rimbursimet Totale',
  'admin.downgrade.pendingRefunds': 'Rimbursimet në Pritje',
  'admin.downgrade.summary': 'Përmbledhja',
  'admin.downgrade.total': 'Gjithsej',
  'admin.downgrade.csvDesc': 'Për Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Shkarko si CSV',
  'admin.downgrade.jsonDesc': 'Për zhvillues, API',
  'admin.downgrade.downloadJSON': 'Shkarko si JSON',
  'admin.downgrade.exportInfo': 'Eksporti përmban',
  'admin.downgrade.entries': 'hyrje nga periudha e zgjedhur',
  'admin.downgrade.topReasons': 'Arsyet më të zakonshme të zbritjes',
  'admin.downgrade.refundHistory': 'Historiku i Rimbursimeve',
  'admin.downgrade.noRefunds': 'Asnjë rimbursim ende',
  'admin.downgrade.statistics': 'Statistikat e Zbritjes',
  'admin.downgrade.requests': 'Kërkesat',
  'admin.downgrade.monthlyTrend': 'Trendi Mujor',
  'admin.downgrade.planTransitions': 'Tranzicionet e Planeve',
  'admin.downgrade.trend': 'Trendi (kundrejt muajit të kaluar)',
  'admin.downgrade.trendDesc': 'Më pak zbritje = më mirë',
  'admin.coupons.allPlansUniversal': 'Të gjitha Planet (Universale)',
  'admin.coupons.onlyStarter': 'Vetëm Starter',
  'admin.coupons.onlyPro': 'Vetëm Pro',
  'admin.coupons.onlyBuilder': 'Vetëm Builder',
  'admin.coupons.allPlansHint': 'Zgjidhni "Të gjitha Planet" për një kupon universal',
  'admin.coupons.discountOptional': 'Zbritja % (opsionale)',
  'admin.coupons.discountPlaceholder': 'p.sh. 50 për 50% zbritje',
  'admin.coupons.bonusCreditsOptional': 'Kredi Bonus (opsionale)',
  'admin.coupons.bonusCreditsPlaceholder': 'p.sh. 500',
  'admin.coupons.freeDurationOptional': 'Kohëzgjatja Falas (opsionale)',
  'admin.coupons.durationPlaceholder': 'p.sh. 30',
  'admin.coupons.freeDurationHint': 'p.sh. 30 ditë përdorim falas',
  'admin.coupons.noLimit': 'Pa kufi përdorimi',
  'admin.coupons.noExpiry': 'Pa datë skadence',
  'admin.coupons.creditsPlaceholder': 'p.sh. 100',
  'admin.coupons.creditsHint': 'Numri i kredive për qasjen provë',
  'admin.coupons.trialDurationHint': 'Sa kohë është e vlefshme qasja provë',
  'admin.coupons.autoCalculated': 'Llogaritur automatikisht nga kohëzgjatja e provës',
  'admin.websiteEditor.title': 'Redaktuesi i Faqes',
  'admin.websiteEditor.subtitle': 'Ndryshoni të gjitha seksionet e faqes kryesore',
  'admin.websiteEditor.openPreview': 'Hap Pamjen Paraprake',
  'admin.websiteEditor.group.structure': 'Struktura e Faqes',
  'admin.websiteEditor.group.design': 'Dizajni dhe Paraqitja',
  'admin.websiteEditor.group.settings': 'Cilësimet',
  'admin.websiteEditor.tab.navbar': 'Navigimi',
  'admin.websiteEditor.tab.howitworks': 'Si Funksionon',
  'admin.websiteEditor.tab.about': 'Rreth Nesh',
  'admin.websiteEditor.tab.pricing': 'Çmimet',
  'admin.websiteEditor.tab.sections': 'Seksionet',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Bisedoni me Ne',
  'admin.websiteEditor.tab.invoice': 'Faturat',
  'admin.websiteEditor.tab.legal': 'Ligjore',
  'admin.websiteEditor.tab.seo': 'SEO Bazë',
  'admin.websiteEditor.tab.advancedseo': 'SEO i Avancuar',
  'admin.websiteEditor.tab.versions': 'Versionet',
  'admin.hero.title': 'Ndrysho Seksionin Hero',
  'admin.hero.subtitle': 'Tekstet, butonat dhe statistikat e faqes kryesore',
  'admin.hero.reset': 'Rivendos',
  'admin.hero.save': 'Ruaj',
  'admin.hero.savedMsg': 'Të dhënat e Heroit u ruajtën!',
  'admin.hero.badge': 'Teksti i Distinktivit',
  'admin.hero.headings': 'Titujt',
  'admin.hero.line1White': 'Rreshti 1 (i bardhë)',
  'admin.hero.line2Gold': 'Rreshti 2 (i artë)',
  'admin.hero.subtitleSection': 'Nëntitulli',
  'admin.hero.line1': 'Rreshti 1',
  'admin.hero.line2': 'Rreshti 2',
  'admin.hero.buttons': 'Butonat',
  'admin.hero.primaryBtn': 'Butoni Primar (i artë)',
  'admin.hero.secondaryBtn': 'Butoni Sekondar (kufiri)',
  'admin.hero.stats': 'Statistikat',
  'admin.hero.statN': 'Statistika {{n}}',
  'admin.hero.value': 'Vlera',
  'admin.hero.label': 'Etiketa',
  'admin.hero.previewNote': 'Ndryshimet do të jenë të dukshme në faqen kryesore pas ruajtjes. Ringarkoni faqen për të parë pamjen paraprake.',

  // Idea History
  'history.title': 'Historia e Ideve',
  'history.countLabel': '{{count}} analiza',
  'history.recentLabel': 'Analizat tuaja të fundit',
  'history.exportAll': 'Eksporto të gjitha',
  'history.metrics.marketSize': 'Madhësia e Tregut',
  'history.metrics.competition': 'Konkurrenca',
  'history.metrics.startingCapital': 'Kapitali Fillestar',
  'history.metrics.timeToMarket': 'Koha për në Treg',
  'history.metrics.profitPotential': 'Potenciali i Fitimit',
  'history.metrics.scalability': 'Shkallëzueshmëria',
  'history.summary.title': 'Përmbledhja',
  'history.download': 'Shkarko',
  'history.downloadJSON': 'Ruaj si JSON',
  'history.downloadTXT': 'Ruaj si TXT',
  'history.downloadPDF': 'Ruaj si PDF',
  'history.fullAnalysis': 'Analiza e Plotë',
  'history.searchPlaceholder': 'Kërko sipas titullit ose etiketave...',
  'history.filterAll': 'Të gjitha vlerësimet',
  'history.loading': 'Duke ngarkuar analizat...',
  'history.noResults': 'Nuk u gjet asnjë rezultat',
  'history.empty': 'Nuk ka analiza ende',
  'history.emptyHint': 'Filloni një analizë te Asistenti AI',
  'history.delete': 'Fshij',
  'history.cancel': 'Anulo',
  'history.deleteModalTitle': 'Të fshihet analiza?',
  'history.deleteModalDesc': '"{{title}}" do të fshihet përgjithmonë.',
  'history.errorLoading': 'Gabim gjatë ngarkimit të analizave',
  'history.deleteSuccess': 'Analiza u fshi me sukses',
  'history.deleteError': 'Gabim gjatë fshirjes së analizës',
  'history.jsonExported': 'JSON u eksportua',
  'history.txtExported': 'TXT u eksportua',
  'history.allExported': '{{count}} ide u eksportuan',
  'history.analysisHeader': 'ANALIZA E IDESË',
  'history.titleLabel': 'Titulli',
  'history.ratingLabel': 'Vlerësimi',
  'history.dateLabel': 'Data',
  'history.creditsLabel': 'Kreditë',
  'history.analysisSection': 'Analiza',

  // Overview
  'overview.title': 'Përmbledhja',
  'overview.last24h': '24 orët e fundit',
  'overview.analysesToday': 'Analiza sot',
  'overview.totalAnalyses': 'Analiza gjithsej',
  'overview.successRate': 'Norma e suksesit',
  'overview.topRatings': 'Vlerësimet kryesore',
  'overview.recentActivity': 'Aktiviteti i fundit',
  'overview.viewAll': 'Shiko të gjitha',
  'overview.quickAccess': 'Qasje e shpejtë',
  'overview.quick.newAnalysis': 'Fillo analizë të re',
  'overview.quick.newAnalysisDesc': 'Fillo një analizë të re të kamareve të fuqizuar nga AI',
  'overview.quick.myAnalyses': 'Analizat e mia',
  'overview.quick.myAnalysesDesc': 'Shiko të gjitha analizat e mëparshme',
  'overview.quick.buyCredits': 'Bli kredi',
  'overview.quick.buyCreditsDesc': 'Më shumë kredi për më shumë analiza',
  'overview.quick.settings': 'Cilësimet',
  'overview.quick.settingsDesc': 'Personalizo profilin dhe preferencat',
  'overview.unlimitedCredits': 'Kredi të pakufizuara në dispozicion',
  'overview.creditsAvailable': 'kredi të disponueshme',
  'overview.upgradePlan': 'Përmirëso planin',
  'overview.buyCredits': 'Bli kredi',
  'overview.creditUsage': 'Përdorimi i kredive këtë muaj',
  'overview.available': 'në dispozicion',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Përmirësimet',
  'admin.transactions.downgrades': 'Zbritjet',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} tani ka {{months}} muaj të planit {{plan}} falas',
  'admin.users.blockSuccess': '{{name}} u bllokua',
  'admin.users.unblockSuccess': '{{name}} u zhbllokua',
  'admin.users.removeFreeSuccess': 'Statusi falas i {{name}} u hoq',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Falas',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Zbuloni Veçorinë e Re',
  'admin.tips.productivityBoost': 'Rritja e Produktivitetit',
  'admin.tips.importantUpdate': 'Përditësim i Rëndësishëm',
  'admin.tips.tipOfDay': 'Këshilla e Ditës',

  'admin.actions.activate': 'Aktivizo',
  'admin.actions.deactivate': 'Çaktivizo',
  'admin.websiteEditor.tab.features': 'Veçoritë',
  'admin.websiteEditor.tab.testimonials': 'Dëshmitë',
  'admin.websiteEditor.tab.faq': 'Pyetjet e shpeshta',
  'admin.websiteEditor.tab.cta': 'Thirrje për Veprim',
  'admin.websiteEditor.tab.footer': 'Fundi i faqes',
  'admin.websiteEditor.tab.design': 'Dizajni',
  'admin.websiteEditor.tab.customcode': 'Kodi i personalizuar',
  'admin.websiteEditor.tab.socials': 'Rrjetet Sociale',
  'admin.websiteEditor.tab.importexport': 'Importo/Eksporto',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Cilësimet e Asistentit AI',
  'admin.ai.subtitle': 'Konfiguroni sjelljen, stilin dhe thellësinë e analizës',
  'admin.ai.smartWeightingActive': 'Pesha e zgjuar Aktive',
  'admin.ai.smartWeightingDesc': 'AI kombinon automatikisht të gjitha perspektivat me peshë të zgjuar. Me shumë paracaktime, e para peshohet më shumë (paracaktimi primar). Ju gjithashtu mund të rregulloni peshën manualisht.',
  'admin.ai.modelTitle': 'Modeli AI IdeaVerdict',
  'admin.ai.modelSubtitle': 'Zgjidhni motorin AI për të gjitha analizat e përdoruesve',
  'admin.ai.activeModel': 'Modeli aktiv:',
  'admin.ai.activeModelDesc': 'Të gjithë përdoruesit marrin përgjigje nga ky model.',
  'admin.ai.recommendations': 'Rekomandime për Rezultate Optimale',
  'admin.ai.new': 'E RE',
  'admin.ai.recommendationsDesc': 'Kombinime të provuara paracaktimesh për cilësinë më të mirë të analizës',
  'admin.ai.recommendationsInfo': 'Këto kombinime janë testuar dhe japin rezultatet më të mira. Klikoni një rekomandim për ta aplikuar direkt.',
  'admin.ai.active': 'AKTIV',
  'admin.ai.apply': 'Apliko',
  'admin.ai.avoid': 'Shmang',
  'admin.ai.excellentQuality': 'Cilësi e Shkëlqyer',
  'admin.ai.goodQuality': 'Cilësi e Mirë',
  'admin.ai.poorQuality': 'Cilësi e Holluar - Nuk Rekomandohet',
  'admin.ai.proTips': 'Këshilla Pro',
  'admin.ai.tip1Title': '2 paracaktime janë optimale:',
  'admin.ai.tip1Desc': 'Perspektivë e qartë pa hollim',
  'admin.ai.tip2Title': 'Paracaktimi primar ka rëndësi:',
  'admin.ai.tip2Desc': 'Paracaktimi i parë ka ndikimin më të madh',
  'admin.ai.tip3Title': 'Shmangni të kundërtat:',
  'admin.ai.tip3Desc': '"EXTREME" + Creative = kontradiktore',
  'admin.ai.tip4Title': 'Maksimumi 3 paracaktime:',
  'admin.ai.tip4Desc': 'Me 4+ paracaktime rezultati bëhet shumë i përgjithshëm',
  'admin.ai.warningManyPresets': 'Paralajmërim: Shumë Paracaktime',
  'admin.ai.warningManyPresetsDesc': 'Ju keni zgjedhur {{count}} paracaktime. Kjo mund të hollojë rezultatin.',
  'admin.ai.warningRecommend': 'Rekomandohet: Maksimumi 2-3 paracaktime',
  'admin.ai.forOptimalResults': 'për rezultate optimale.',
  'admin.ai.presets': 'Paracaktime',
  'admin.ai.multiSelect': '(përzgjedhje e shumëfishtë e mundshme)',
  'admin.ai.presetsDesc': 'Zgjidhni një ose më shumë paracaktime. Paracaktimi i parë është paracaktimi primar me peshën më të lartë.',
  'admin.ai.primaryPreset': 'Paracaktimi Primar',
  'admin.ai.weightControl': 'Kontrolli i Peshave',
  'admin.ai.weightControlDesc': 'Rregulloni sa fuqishëm ndikon secili paracaktim në analizë',
  'admin.ai.manual': 'Manuale',
  'admin.ai.automatic': 'Automatike',
  'admin.ai.autoWeightingActive': 'Pesha automatike aktive:',
  'admin.ai.autoWeightingDesc': 'Pesha optimizohet automatikisht bazuar në numrin e paracaktimeve.',
  'admin.ai.primary': 'PRIMAR',
  'admin.ai.totalWeight': 'Gjithsej',
  'admin.ai.shouldBe100': 'duhet të jetë 100%',
  'admin.ai.normalize': 'Normalizo',
  'admin.ai.combinedSettings': 'Cilësimet e Kombinuara',
  'admin.ai.presetsCount': 'paracaktime',
  'admin.ai.strictness': 'Rreptësia',
  'admin.ai.realism': 'Realizmi',
  'admin.ai.creativity': 'Kreativiteti',
  'admin.ai.detailLevel': 'Niveli i Detajeve',
  'admin.ai.customInstructions': 'Udhëzime të Personalizuara',
  'admin.ai.customInstructionsDesc': 'Udhëzime shtesë që kombinohen me paracaktime',
  'admin.ai.customInstructionsPlaceholder': 'p.sh. "Fokusohu në tregun DACH", "Përdor gjithmonë numra konkretë", "Krahaso me konkurrentët ekzistues", "Përgjigju gjithmonë me shembuj"...',
  'admin.ai.customInstructionsHint': 'Këto udhëzime kombinohen automatikisht me paracaktime të zgjedhura.',
  'admin.ai.manualFinetuning': 'Rregullim i Hollë Manual',
  'admin.ai.manualFinetuningHint': '(opsionale, anashkalon vlerat e paracaktimeve)',
  'admin.ai.manualFinetuningDesc': 'Rregulloni manualisht vlerat e kombinuara nëse doni të bëni rregullime të holla.',
  'admin.ai.tone': 'Ton',
  'admin.ai.mild': 'I butë',
  'admin.ai.strict': 'I rreptë',
  'admin.ai.creative': 'Kreativ',
  'admin.ai.realistic': 'Realist',
  'admin.ai.conservative': 'Konservator',
  'admin.ai.compact': 'Kompakt',
  'admin.ai.detailed': 'I detajuar',
  'admin.ai.responseLength': 'Gjatësia e Përgjigjes',
  'admin.ai.short': 'E shkurtër dhe koncize',
  'admin.ai.medium': 'Mesatare',
  'admin.ai.long': 'E detajuar',
  'admin.ai.focusAreas': 'Fushat e Fokusit të Analizës',
  'admin.ai.autoRating': 'Vlerësimi Automatik',
  'admin.ai.autoRatingDesc': 'Çdo analizë merr automatikisht një vlerësim (Mirë/Mesatar/Keq)',
  'admin.ai.showSources': 'Shfaq Burimet',
  'admin.ai.showSourcesDesc': 'Referenca për burimet e të dhënave dhe të dhënat e tregut në përgjigje',
  'admin.ai.hidePreview': 'Fshih Pamjen Paraprake',
  'admin.ai.showPreview': 'Shfaq Pamjen Paraprake',
  'admin.ai.aiBehavior': 'Sjellja e AI',
  'admin.ai.length': 'Gjatësia',
  'admin.ai.liveExample': 'Shembull i Drejtpërdrejtë',
  'admin.ai.testSettings': 'Testoni cilësimet tuaja',
  'admin.ai.selectExampleQuestion': 'Zgjidhni pyetjen shembull:',
  'admin.ai.userAsks': 'Përdoruesi pyet:',
  'admin.ai.generating': 'AI duke gjeneruar përgjigje...',
  'admin.ai.generateExample': 'Gjenero Përgjigje Shembull',
  'admin.ai.aiResponds': 'Asistenti AI përgjigjet:',
  'admin.ai.generateHint': 'Klikoni "Gjenero Përgjigje Shembull" për të parë se si përgjigjet AI me cilësimet tuaja.',
  'admin.ai.reset': 'Rivendos',
  'admin.ai.saved': 'U ruajt!',
  'admin.ai.saveSettings': 'Ruaj Cilësimet',

  // --- Table headers ---
  'admin.coupons.code': 'Kodi',
  'admin.coupons.credits': 'Kreditë',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Analizë e balancuar me cilësi të lartë. Zgjedhja më e mirë për shumicën e vlerësimeve të kamareve dhe validimeve të ideve.',
  'admin.ai.model.preciseAnalyses': 'Analiza të Sakta',
  'admin.ai.model.bestBalance': 'Balanca më e Mirë',
  'admin.ai.model.recommended': 'Rekomandohet',
  'admin.ai.model.fastDesc': 'Përgjigje rrufe të shpejta për kontrolle të shpejta të kamareve, ide dhe vlerësime fillestare. Ideale kur shpejtësia ka rëndësi.',
  'admin.ai.model.fast': 'I SHPEJTË',
  'admin.ai.model.fastestResponses': 'Përgjigjet më të Shpejta',
  'admin.ai.model.thinkingDesc': 'Analizë e thellë me të menduar logjik të avancuar. Për analiza komplekse të tregut, vlerësime kritike dhe planifikim strategjik.',
  'admin.ai.model.deepestAnalysis': 'Analiza më e Thellë',
  'admin.ai.model.logicalThinking': 'Të Menduarit Logjik',
  'admin.ai.model.strategy': 'Strategjia',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Analizë e Rreptë',
  'admin.ai.preset.strict.desc': 'Kritike, e bazuar në fakte, pa sheqerosje. E ekspozon dobësitë pa mëshirë.',
  'admin.ai.preset.extreme.name': 'Analizë EXTREME',
  'admin.ai.preset.extreme.desc': 'Rreptësi maksimale, kritikë e pamëshirshme, fokus në skenarin më të keq. Vetëm për kontrolle të vështira të realitetit.',
  'admin.ai.preset.professional.name': 'Profesionale',
  'admin.ai.preset.professional.desc': 'Objektive, e strukturuar, e balancuar. Si një konsulent biznesi me përvojë.',
  'admin.ai.preset.realistic.name': 'Realist',
  'admin.ai.preset.realistic.desc': 'I ndershëm dhe praktik. Fokus në zbatimin e realizueshëm dhe të dhënat reale të tregut.',
  'admin.ai.preset.creative.name': 'Kreativ dhe Motivues',
  'admin.ai.preset.creative.desc': 'Frymëzues, i pasur me ide, pozitiv. Gjen mundësi dhe rrugë jo konvencionale.',
  'admin.ai.preset.balanced.name': 'I Balancuar',
  'admin.ai.preset.balanced.desc': 'Përzierje e mirë e kritikës dhe motivimit. Modaliteti i parazgjedhur.',
  'admin.ai.preset.investor.name': 'Perspektiva e Investitorit',
  'admin.ai.preset.investor.desc': 'Si një Kapitalist Sipërmarrës. Fokus në shkallëzim, ROI dhe strategjinë e daljes.',
  'admin.ai.preset.startup-coach.name': 'Trajner Start-up-i',
  'admin.ai.preset.startup-coach.desc': 'Mentor praktik për themeluesit. Fokus në zbatimin e shpejtë dhe MVP.',
  'admin.ai.preset.market-researcher.name': 'Hulumtues Tregu',
  'admin.ai.preset.market-researcher.desc': 'I bazuar në të dhëna dhe analitik. Analizë e thellë e tregut dhe konkurrencës.',
  'admin.ai.preset.risk-analyst.name': 'Analist Rreziku',
  'admin.ai.preset.risk-analyst.desc': 'Fokus në rreziqet dhe skenarët më të këqij. Për planifikim realist.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Analiza e Tregut',
  'admin.ai.focus.wettbewerb': 'Konkurrenca',
  'admin.ai.focus.monetarisierung': 'Monetizimi',
  'admin.ai.focus.risiken': 'Rreziqet',
  'admin.ai.focus.finanzen': 'Financat',
  'admin.ai.focus.skalierung': 'Shkallëzimi',
  'admin.ai.focus.innovation': 'Inovacioni',
  'admin.ai.focus.trends': 'Trendet',
  'admin.ai.focus.differenzierung': 'Diferencimi',
  'admin.ai.focus.umsetzung': 'Zbatimi',
  'admin.ai.focus.zielgruppe': 'Grupi i Synuar',
  'admin.ai.focus.marketing': 'Marketingu',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direkt dhe i Ashpër',
  'admin.ai.tone.professionell': 'Profesional dhe Objektiv',
  'admin.ai.tone.ehrlich': 'I ndershëm dhe Praktik',
  'admin.ai.tone.motivierend': 'Motivues dhe Pozitiv',
  'admin.ai.tone.freundlich': 'Miqësor dhe Mbështetës',
  'admin.ai.tone.akademisch': 'Akademik dhe Analitik',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Cilën kamare fitimprurëse rekomandoni?',
  'admin.ai.question.evaluate': 'Vlerëso idenë time: Një aplikacion për pronarët e qenve',
  'admin.ai.question.trends': 'Cilat trende kanë potencial aktualisht?',
  'admin.ai.question.sharpen': 'Si mund ta mpreh kamanë time?',

  'admin.ai.rec.bestCombination.title': '🏆 Kombinimi më i Mirë (2 Paracaktime)',
  'admin.ai.rec.bestCombination.desc': 'Kritik por konstruktiv, me hapa veprimi konkret',
  'admin.ai.rec.bestCombination.useCase': 'Rekomandohet për shumicën e analizave',

  'admin.ai.rec.balancedThree.title': '⚖️ I Balancuar (3 Paracaktime)',
  'admin.ai.rec.balancedThree.desc': 'Profesional, realist dhe miqësor për investitorët',
  'admin.ai.rec.balancedThree.useCase': 'Për analiza gjithëpërfshirëse biznesi',

  'admin.ai.rec.creativeDriven.title': '💡 Kreativ dhe Motivues (2 Paracaktime)',
  'admin.ai.rec.creativeDriven.desc': 'Frymëzues me këshilla praktike zbatimi',
  'admin.ai.rec.creativeDriven.useCase': 'Për gjenerim idesh dhe stuhi mendimesh',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Hap menynë',
  'header.home': 'Faqja kryesore',
  'header.notifications': 'Njoftimet',
  'header.settings': 'Cilësimet',
  'header.profile': 'Profili',
  'sidebar.collapse': 'Mbyll shiritin anësor',
  'sidebar.expand': 'Hap shiritin anësor',
  'sidebar.close': 'Mbyll menynë',
  'sidebar.plan': 'Plani',
  'sidebar.backToWebsite': 'Kthehu te faqja',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Mirëserdhe sërish',
  'overview.greetingSub': 'Ja çfarë po ndodh në tavolinën tënde të verdikteve.',
  'overview.heroCta': 'Verdikt i ri',
  'overview.currentPlan': 'Plani aktual',
  'overview.creditsLabel': 'kredite',
  'overview.usedThisCycle': 'Përdorur këtë cikël',
  'overview.resetsOn': 'Rivendoset më',
  'overview.unlimitedTitle': 'I pakufizuar',
  'overview.builderPerk': 'Ke akses të plotë Builder — pa kufij.',
  'overview.runOne': 'Nis një verdikt',
  'overview.lastVerdicts': '5 verdiktet e tua të fundit',
  'overview.noActivity': 'Ende pa verdikte — fillo analizën e parë',
  'overview.tipTitle': 'Këshillë',
  'overview.tipBody': 'Provoje një ide në dy gjuhë — nëse verdikti zbutet në njërën, supozimet e tua janë lokale, jo universale.',
  'onboard.skip': "Kapërce",
  'onboard.cta.next': "Tjetra",
  'onboard.cta.start': "Fillo",
  'onboard.s1.title': "Mirë se vini në IdeaVerdict",
  'onboard.s1.body': "Verdikti i AI-së për idenë tuaj të biznesit — para se ta ndërtoni.",
  'onboard.s2.title': "Verdikte brutalisht të sinqerta",
  'onboard.s2.body': "Pa zhurmë, pa lajka. Të dhëna reale të tregut, konkurrentë realë, rreziqe reale.",
  'onboard.s3.title': "Raporte Builder në PDF",
  'onboard.s3.body': "Gjeneroni raporte 25–75 faqesh me arkitekturë të plotë, financa dhe strategji daljeje në treg.",
  'onboard.s4.title': "Kur të jeni gati",
  'onboard.s4.body': "Regjistrohuni dhe merrni verdiktin tuaj të parë brenda një minute.",
  'builderReport.title': "Building your Builder Report",
  'builderReport.subtitle': "Comprehensive analysis + developer briefing — downloads as PDF when ready.",
  'builderReport.idea': "Your idea",
  'builderReport.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'builderReport.cta': "Generate Report",
  'builderReport.credits': "credits",
  'builderReport.deductedNow': "Deducted on success",
  'builderReport.dontClose': "Please don't close this window — generation can take 30-90 seconds.",
  'builderReport.done': "PDF downloaded — check your downloads folder.",
  'builderReport.failed': "Krijimi dështoi",
  'builderReport.close': "Close",
  'builderReport.cancel': "Cancel",
  'builderReport.running': "Generating…",
  'builderReport.retry': "Try again",
  'builderReport.unknownError': "Generation failed. Your credits should be refunded.",
  'builderReport.signInRequired': "You must be signed in to generate a report.",
  'builderReport.ideaRequired': "Please describe your idea so the AI has something to analyze.",
  'builderReport.fromChat': "From your current conversation",
  'builderReport.noIdeaDetected': "Using the idea we have been discussing.",
  'builderReport.contextHint': "The AI will use everything from this chat — no new idea will be invented.",
  'builderReport.step.core': "Generating core analysis",
  'builderReport.step.market': "Adding extended market analysis",
  'builderReport.step.tech': "Adding technical architecture",
  'builderReport.step.financials': "Adding financial models",
  'builderReport.step.compet': "Adding competitive intelligence",
  'builderReport.step.gtm': "Adding go-to-market strategy",
  'builderReport.step.deepdive': "Adding industry deep-dive",
  'builderReport.step.pdf': "Compiling the PDF…",
  'briefing.title': "Building your Developer Briefing",
  'briefing.subtitle': "11-section technical briefing — downloads as PDF when ready.",
  'briefing.ideaPlaceholder': "Describe your business idea (or leave blank to use the last idea you discussed)…",
  'briefing.cta': "Generate Briefing",
  'briefing.step.core': "Generating developer briefing",
  'briefing.step.pdf': "Compiling the PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Më shumë kredite + raporte 50 faqesh",
  'pricing.gold.credits': "12,500 Kredite në muaj",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Niveli maksimal + raporte 75 faqesh",
  'pricing.platinum.credits': "15,000 Kredite në muaj",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "sq" yet. Replace with native translations as needed.
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Only {{count}} Credits left!",
  'trial.upgradeNow': "Përmirëso tani →",
  'trial.upgradeNowArrow': "Upgrade now →",
  'trial.creditsExhausted': "Credits exhausted",
  'trial.upgradeForUnlimited': "Upgrade for unlimited use",
  'trial.noCreditsPlaceholder': "No credits left…",
  'hero.badgeHonest': "Brutalisht i sinqertë",
  'hero.badge60sec': "Verdikt në 60 sekonda",
  'hero.badge20Lang': "20+ gjuhë",
  'hero.widget.label': "Verdikti i Idesë",
  'hero.widget.passed': "KALOI",
  'hero.widget.demoIdea': "Tutor me AI për studentë të mjekësisë",
  'hero.widget.market': "Tregu",
  'hero.widget.demand': "Kërkesa",
  'hero.widget.competition': "Konkurrenca",
  'hero.widget.verdictReady': "Verdikti gati · 47 sek",
  'hero.widget.riskFlagged': "Rrezik i sinjalizuar",
  'hero.widget.crowdedMarket': "Crowded market · 4 incumbents",
  'hero.widget.suggestedPivot': "Pivot i sugjeruar",
  'hero.widget.nicheBySpecialty': "Niche by specialty",
  'hero.widget.feasibilityGain': "+38% feasibility",
  'hero.widget.analysisDone': "Analiza e përfunduar",
  'hero.widget.metrics56': "5 of 6 metrics",
  'hero.stats.verdictSpeed': "Verdict speed",
  'cta.badge': "Verdikt në 60 sekonda",
  'cta.subtitleEnd': "pa hamendje.",
  'cta.signinPrompt': "Keni tashmë një llogari? Hyni",
  'cta.trustTrial': "Provë falas 7-ditore",
  'cta.trustNoCard': "Pa nevojë për kartë",
  'cta.trustCancel': "Anuloni në çdo kohë",
  'footer.themeLabel': "Tema:",
  'footer.lightMode': "Modaliteti i Çelët",
  'footer.darkMode': "Modaliteti i Errët",
  'footer.sectionProduct': "Produkti",
  'footer.sectionLegal': "Ligjore",
  'nav.switchLight': "Kalo në modalitetin e çelët",
  'nav.switchDark': "Kalo në modalitetin e errët",
  'features.badge': "Pse IdeaVerdict",
  'features.mainFeatureLabel': "Titulli",
  'faq.badge': "FAQ",
  'trial.lowCredits': "Vetëm {credits} kredite kanë mbetur!",
  'trial.outOfCredits': "Pa kredite",
  'trial.outOfCreditsDesc': "Përmirësoni për të vazhduar të merrni verdikte.",
  'trial.viewPlans': "Shiko planet",
  'trial.tryDemo': "Provo demon",
  'hero.widget.crowded': "Treg i mbingarkuar · 4 të vendosur",
  'hero.widget.nicheBySpec': "Niche sipas specialitetit",
  'hero.widget.feasibilityUp': "+38% fizibilitet",
  'hero.widget.fiveOfSix': "5 nga 6 metrika",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Gjeneroni një PDF gjithëpërfshirës për idenë tuaj",
  'builderReport.formatLabel': "Formati i raportit",
  'builderReport.formatStandard': "Raport standard",
  'builderReport.formatExec': "Përmbledhje ekzekutive",
  'builderReport.toneLabel': "Toni",
  'builderReport.toneProfessional': "Profesional",
  'builderReport.toneCasual': "Joformal",
  'builderReport.toneTechnical': "Teknik",
  'builderReport.sectionsLabel': "Seksionet që do të përfshihen",
  'builderReport.sectionMarket': "Analiza e tregut",
  'builderReport.sectionCompetition': "Peizazhi konkurrues",
  'builderReport.sectionFinancial': "Modeli financiar",
  'builderReport.sectionArchitecture': "Arkitektura teknike",
  'builderReport.sectionGTM': "Plani i daljes në treg",
  'builderReport.sectionRisks': "Regjistri i rreziqeve",
  'builderReport.sectionRoadmap': "Udhërrëfyesi i produktit",
  'builderReport.sectionTeam': "Ekipi & plani i punësimit",
  'builderReport.actionGenerate': "Gjenero raportin",
  'builderReport.actionCancel': "Anulo",
  'builderReport.actionDownload': "Shkarko PDF",
  'builderReport.statusGenerating': "Po gjenerohet raporti juaj…",
  'builderReport.statusComplete': "Raporti gati",
  'builderReport.statusError': "Diçka shkoi keq. Provoni përsëri.",
  'builderReport.creditsRequired': "Kjo do të përdorë {credits} kredite.",
  'builderReport.pageCount': "{pages} faqe",
  'builderReport.tip1': "Këshillë: jini specifik për klientin tuaj të synuar për analizë më të mprehtë.",
  'builderReport.tip2': "Këshillë: përfshini shifrat e hershme të të ardhurave nëse i keni.",
  'builderReport.tip3': "Këshillë: përmendni preferencat tuaja teknologjike nëse keni.",
  'builderReport.errorNotEnough': "Nuk keni kredite të mjaftueshme për këtë raport.",
  'builderReport.errorUpgrade': "Përmirësoni në një plan më të lartë",
  'builderReport.errorTryStandard': "Provoni raportin Standard në vend",
  'builderReport.success': "Builder Report-i juaj është gati.",
  'builderReport.previewBadge': "Pamje paraprake",
  'builderReport.previewNote': "Kjo është një pamje paraprake. Gjeneroni PDF-në e plotë për të parë të gjitha seksionet.",
  'builderReport.includesLabel': "Përfshin",
  'builderReport.pagesIncluded': "{pages} faqe analize",
  'builderReport.estimatedTime': "Koha e parashikuar: {minutes} min",
  'builderReport.fullReport': "Raporti i plotë",
  'builderReport.execSummary': "Përmbledhje ekzekutive",
  'chatError.planRestriction': "Ky funksion kërkon një plan më të lartë.",
  'chatError.creditDeduction': "Përpunimi i pagesës dështoi. Ju lutemi provoni përsëri.",
  'chatError.aiService': "Shërbimi AI është përkohësisht i padisponueshëm. Kreditet tuaja nuk janë tarifuar. Ju lutemi provoni përsëri.",
  'chatError.parseError': "U mor një format përgjigjeje i papritur. Ju lutemi provoni përsëri.",
  'chatError.sessionExpired': "Sesioni juaj ka skaduar. Ju lutemi hyni përsëri.",
  'chatError.timeout': "Kërkesa zgjati shumë. Ju lutemi provoni përsëri.",
  'chatError.generic': "Dështoi marrja e përgjigjes. Ju lutemi provoni përsëri.",
  'pricing.builder.report': "Builder Report me 25 faqe",
  'pricing.gold.report': "Builder Report me 50 faqe",
  'pricing.platinum.report': "Builder Report me 75 faqe",
  'auth.bestValue': "Vlera më e mirë",
  'auth.elite': "Elitë",
  'builderReport.friendlyError': "Nuk arritëm ta përfundojmë raportin tuaj këtë herë. Kreditet tuaja nuk u tarifuan — ju lutemi provoni përsëri pas një momenti.",
  'builderReport.persistHint': "Nëse problemi vazhdon, kontaktoni support@ideaverdict.ai.",
};
